{
  "nav.customers": "客户",
  "nav.products": "商品",
  "nav.orders": "订单",
  "nav.drivers": "司机",
  "nav.driverProfiles": "司机画像",
  "nav.userManagement": "成员与权限",
  "nav.dispatch": "物流配送",
  "nav.overview": "总览",
  "nav.jobs": "配送单",
  "nav.reviewQueue": "运营收件箱",
  "nav.packaging": "配送单打印",
  "routePlanning.title": "路线",
  "routePlanning.description": "查看配送路线、已定位的配送站点，以及仍缺少坐标的配送单。",
  "routePlanning.date": "配送日期",
  "routePlanning.loading": "正在加载路线…",
  "routePlanning.error": "无法加载路线。",
  "routePlanning.etaError": "实时司机数据暂不可用——地图上的司机归属可能已过时。",
  "routePlanning.stopCount_one": "{{count}} 个地图站点",
  "routePlanning.stopCount_other": "{{count}} 个地图站点",
  "routePlanning.sidebarTitle": "路线预计送达",
  "routePlanning.todayOnlyNotice": "实时路线监控与司机定位仅支持今日配送单。",
  "routePlanning.liveMonitoringActive_one": "正在实时监控 {{count}} 位司机",
  "routePlanning.liveMonitoringActive_other": "正在实时监控 {{count}} 位司机",
  "routePlanning.missing.title": "无坐标配送单",
  "routePlanning.missingCount": "{{count}} 个缺失",
  "routePlanning.missingReason.order_not_found": "未找到订单",
  "routePlanning.missingReason.no_address": "没有配送地址",
  "routePlanning.missingReason.unresolved": "无法解析坐标",
  "routePlanning.unknownOrder": "未知订单",
  "routePlanning.popup.order": "订单",
  "routePlanning.popup.driver": "司机",
  "routePlanning.popup.zip": "邮编",
  "routePlanning.popup.status": "状态",
  "routePlanning.popup.completedAt": "送达时间",
  "routePlanning.popup.eta": "预计送达",
  "routePlanning.map.ariaLabel": "路线规划地图",
  "routePlanning.driver.offDuty": "不在班",
  "routePlanning.driver.lastSeen": "{{minutes}} 分钟前",
  "routePlanning.driver.onlyDriver": "只看 {{name}}",
  "routePlanning.driver.showAll": "显示全部",
  "routePlanning.driver.toggleTasks": "展开或收起司机任务",
  "routePlanning.filter.placeholder": "查找司机任务（如 #87201HGS-0914）",
  "routePlanning.filter.noMatch": "无匹配司机任务",
  "routePlanning.openJobDetail": "打开配送单",
  "routePlanning.unlinked.notInTodayStops": "不在当日站点中",
  "routePlanning.unlinked.notInTodayStopsHint": "该司机任务的 id 不在当日的配送单站点中，因此无法定位到路线上。",
  "routePlanning.fullscreen.enter": "进入全屏",
  "routePlanning.fullscreen.exit": "退出全屏",
  "routePlanning.legend.title": "图例",
  "routePlanning.legend.delivered": "已送达（司机色实心）",
  "routePlanning.legend.pending": "待送（空心描边）",
  "routePlanning.legend.unassigned": "未分配（灰实心）",
  "routePlanning.legend.unknown": "等待实时数据（灰描边）",
  "routePlanning.legend.driver": "司机位置（失联转灰）",
  "routePlanning.legend.routeDone": "实线：已走",
  "routePlanning.legend.routePending": "虚线：待走",
  "routePlanning.unassigned.title": "未分配",
  "routePlanning.unassignedCount_one": "{{count}} 个停靠点",
  "routePlanning.unassignedCount_other": "{{count}} 个停靠点",
  "audit.pageTitle": "审计日志",
  "webhooks.pageTitle": "Webhooks",
  "audit.filtersTitle": "筛选",
  "audit.routeLabel": "路由",
  "audit.routePlaceholder": "/api/orders/:id/cancel",
  "audit.actorLabel": "操作人",
  "audit.actorPlaceholder": "user_abc123",
  "audit.fromLabel": "起始时间",
  "audit.toLabel": "结束时间",
  "audit.unavailableNote": "路由筛选需匹配完整 API 路径；审计台账不支持全文搜索和按来源筛选。",
  "audit.loadFailed": "加载审计记录失败。",
  "audit.resetFilters": "重置筛选",
  "audit.colTimestamp": "时间",
  "audit.colActor": "操作人",
  "audit.colMethod": "方法",
  "audit.colRoute": "路由",
  "audit.colOutcome": "结果",
  "audit.outcome.ok": "成功",
  "audit.outcome.error": "失败",
  "audit.empty": "当前筛选条件下暂无审计记录。",
  "audit.pagerHint": "第 {{page}} 页",
  "audit.prev": "上一页",
  "audit.next": "下一页",
  "audit.requestPath": "请求路径",
  "audit.permission": "权限",
  "audit.errorMessage": "错误",
  "audit.traceId": "追踪 ID",
  "audit.created": "创建",
  "audit.updated": "更新",
  "audit.deleted": "删除",
  "audit.restored": "恢复",
  "audit.justNow": "刚刚",
  "audit.minutesAgo": "{{count}} 分钟前",
  "audit.hoursAgo": "{{count}} 小时前",
  "audit.daysAgo": "{{count}} 天前",
  "audit.recordCreated": "记录已创建",
  "audit.recordDeleted": "记录已删除",
  "audit.recordUpdated": "记录已更新",
  "audit.recordRestored": "记录已恢复",
  "audit.initialValues": "初始值",
  "audit.deletedRecord": "已删除记录",
  "audit.changes": "变更",
  "audit.noChanges": "暂无变更记录",
  "audit.jsonDiff.fieldsChanged_one": "{{count}} 处子字段变化",
  "audit.jsonDiff.fieldsChanged_other": "{{count}} 处子字段变化",
  "audit.jsonDiff.equivalent": "字段值未变化（仅序列化差异）",
  "audit.jsonDiff.viewRaw": "查看原始 JSON",
  "audit.loadMore": "加载更多",
  "audit.loadingMore": "加载中…",
  "audit.showingAll_one": "已加载全部 {{count}} 条变更",
  "audit.showingAll_other": "已加载全部 {{count}} 条变更",
  "audit.shopifyActor.ask": "查询 Shopify 操作记录",
  "audit.shopifyActor.loading": "正在向 Shopify 查询…",
  "audit.shopifyActor.scope": "Shopify 能追溯到人的操作：创建、上架、下架、更改状态，以及修改客户的邮箱或电话。其他字段编辑——价格、标题、地址——无法追溯：Shopify 不记录是谁改的。",
  "audit.shopifyActor.failed": "无法连接 Shopify。本次未加载任何操作者信息——这不代表没有人改过这条记录。",
  "audit.shopifyActor.srLabel": "Shopify 操作者",
  "audit.updated.summary": "更新了{{field}}",
  "audit.restored.summary": "恢复了{{field}}",
  "audit.more": "还有 {{count}} 项",
  "audit.actor.system": "系统",
  "audit.actor.cron": "定时任务",
  "audit.actor.backfill": "回填任务",
  "audit.actor.smoke": "冒烟测试",
  "audit.actor.unknown": "未知用户",
  "audit.actor.systemHint": "非用户操作者（系统、Webhook 或定时任务）",
  "audit.actor.srLabel": "操作者",
  "audit.time.srLabel": "更新时间",
  "audit.actor.shopifyWebhook": "Shopify Webhook",
  "audit.actor.shopifyWebhookWithEvent": "Shopify · {{event}}",
  "audit.actor.onfleetWebhook": "Onfleet Webhook",
  "audit.actor.onfleetWebhookWithEvent": "Onfleet · {{event}}",
  "audit.actor.manualUnattributed": "手动（操作者未记录）",
  "audit.tab.requests.description": "谁在什么时间调用了哪个特权 API、结果如何。记录的是请求，不是数据。",
  "audit.tab.changes.description": "哪条数据的哪个字段被改成了什么、由谁或哪个 webhook 触发。记录的是数据变更本身。",
  "audit.colResourceType": "资源类型",
  "audit.colResource": "资源",
  "audit.colAction": "动作",
  "audit.colSource": "来源",
  "audit.colChangeSummary": "变更摘要",
  "audit.resourceType.orders": "订单",
  "audit.resourceType.customers": "客户",
  "audit.resourceType.products": "商品",
  "audit.resourceType.fulfillment_jobs": "配送单",
  "audit.resourceType.tenant_settings": "租户设置",
  "audit.source.manual": "手动",
  "audit.source.shopify_webhook": "Shopify Webhook",
  "audit.source.onfleet_webhook": "Onfleet Webhook",
  "audit.source.cron": "定时任务",
  "audit.source.backfill": "回填任务",
  "audit.source.smoke": "冒烟测试",
  "webhookHealth.title": "Webhook 健康",
  "webhookHealth.subtitle": "基于已记录事件，按 topic 展示所选时间窗内 webhook 的投递健康。需重点关注已声明但零事件（静默）的 topic，以及未声明却出现的漂移 topic。",
  "webhookHealth.onfleet.title": "Onfleet — 最近一次对账快照",
  "webhookHealth.onfleet.deliveryTitle": "Onfleet — Topic 投递健康",
  "webhookHealth.refresh": "刷新",
  "webhookHealth.reconcileNow": "立即对账",
  "webhookHealth.loading": "加载中…",
  "webhookHealth.empty": "暂无对账快照——点击立即对账以生成。",
  "webhookHealth.lastReconciled": "最近对账",
  "webhookHealth.active": "存活",
  "webhookHealth.reconcileErrors": "对账错误",
  "webhookHealth.table.name": "名称",
  "webhookHealth.table.trigger": "触发器",
  "webhookHealth.table.status": "状态",
  "webhookHealth.table.count": "成功投递数",
  "webhookHealth.table.id": "Onfleet ID",
  "webhookHealth.status.ok": "正常",
  "webhookHealth.status.created": "已创建",
  "webhookHealth.status.rebuilt": "已重建",
  "webhookHealth.status.error": "错误",
  "webhookHealth.status.disabled": "已禁用",
  "webhookHealth.toast.reconciled": "对账完成",
  "webhookHealth.error": "Webhook 健康请求失败",
  "webhookHealth.shopify.title": "Shopify — Topic 投递健康",
  "webhookHealth.shopify.window": "时间窗口",
  "webhookHealth.shopify.windowHours": "最近 {{hours}} 小时",
  "webhookHealth.shopify.windowSwitcher.label": "时间窗口",
  "webhookHealth.shopify.windowSwitcher.6h": "6 小时",
  "webhookHealth.shopify.windowSwitcher.24h": "24 小时",
  "webhookHealth.shopify.windowSwitcher.3d": "3 天",
  "webhookHealth.shopify.windowSwitcher.7d": "7 天",
  "webhookHealth.shopify.windowSwitcher.30d": "30 天",
  "webhookHealth.shopify.totals.events": "声明 topic 事件数",
  "webhookHealth.shopify.totals.errorRate": "声明 topic 错误率",
  "webhookHealth.shopify.driftAlert": "检测到订阅漂移——至少有一个已接收的 topic 不在应用声明的处理集合中。请检查该 provider 的 webhook 订阅设置。",
  "webhookHealth.shopify.table.topic": "Topic",
  "webhookHealth.shopify.table.status": "状态",
  "webhookHealth.shopify.table.total": "总数",
  "webhookHealth.shopify.table.completed": "已完成",
  "webhookHealth.shopify.table.success": "成功",
  "webhookHealth.shopify.table.failed": "失败",
  "webhookHealth.shopify.table.errorRate": "错误率",
  "webhookHealth.shopify.table.lastSeen": "最近一次",
  "webhookHealth.shopify.table.lastError": "最近错误",
  "webhookHealth.shopify.status.healthy": "健康",
  "webhookHealth.shopify.status.degraded": "退化",
  "webhookHealth.shopify.status.unhealthy": "异常",
  "webhookHealth.shopify.status.silent": "静默",
  "webhookHealth.shopify.status.drift": "漂移",
  "webhookHealth.shopify.emptyError": "(无错误信息)",
  "nav.kitchen": "厨房管理",
  "nav.workbench": "工作台",
  "nav.delivery": "配送",
  "nav.ordersProducts": "订单与商品",
  "nav.sidebarTitle": "导航",
  "nav.driversAndProfiles": "司机与司机画像",
  "nav.audit": "审计",
  "nav.webhooks": "Webhooks",
  "nav.kitchen.dishesCombos": "菜品与套餐",
  "nav.kitchen.ingredientsStock": "食材与库存",
  "nav.kitchen.procurementSuppliers": "采购与供应商",
  "nav.openMenu": "切换导航",
  "theme.toggle": "切换主题",
  "language.switch": "切换语言",
  "shell.clock": "{{weekday}} {{date}} · {{time}} {{zone}}",
  "shell.phoneToday": "今天 {{md}} {{weekday}} · {{time}} {{zone}}",
  "mobileNav.label": "底部导航",
  "mobileNav.now": "现在",
  "mobileNav.jobs": "配送单",
  "mobileNav.inbox": "收件箱",
  "mobileNav.more": "更多",
  "nav.management": "设置",
  "nav.admin": "管理",
  "nav.profile": "用户资料",
  "nav.logout": "退出登录",
  "nav.brandSubtitle": "运营控制台",
  "ui.loading": "加载中...",
  "ui.today": "今天",
  "ui.relativeEta.imminent": "即将送达",
  "ui.relativeEta.minutes": "约 {{minutes}} 分钟后",
  "ui.relativeEta.hours": "约 {{hours}} 小时后",
  "ui.relativeEta.hoursMinutes": "约 {{hours}} 小时 {{minutes}} 分后",
  "ui.relativeEta.overdue": "已超时 {{minutes}} 分钟",
  "ui.loadingMore": "加载更多",
  "ui.noData": "暂无数据",
  "ui.openInShopify": "在 Shopify 中打开",
  "ui.openInOnfleet": "在 Onfleet 中打开",
  "ui.save": "保存",
  "ui.cancel": "取消",
  "ui.confirm": "确认",
  "ui.view": "查看",
  "ui.export": "导出",
  "ui.filter": "筛选",
  "ui.clear": "清除",
  "ui.selectAll": "全选",
  "ui.refresh": "刷新",
  "ui.retry": "重试",
  "ui.back": "返回",
  "ui.next": "下一步",
  "ui.previous": "上一步",
  "ui.submit": "提交",
  "ui.close": "关闭",
  "ui.processing": "处理中...",
  "ui.ok": "确定",
  "ui.on": "开启",
  "ui.off": "关闭",
  "ui.none": "无",
  "ui.done": "完成",
  "ui.refreshPage": "刷新页面",
  "ui.usingDefault": "(使用环境默认)",
  "ui.currentValue": "当前有效值：",
  "form.name": "姓名",
  "form.phone": "电话",
  "form.email": "邮箱",
  "form.address": "地址",
  "form.status": "状态",
  "form.date": "日期",
  "form.time": "时间",
  "form.notes": "备注",
  "form.description": "描述",
  "form.startDate": "开始日期",
  "form.endDate": "结束日期",
  "form.fromDate": "起始日期",
  "form.toDate": "结束日期",
  "form.worker": "司机",
  "form.vehicle": "车辆",
  "form.location": "位置",
  "error.network": "网络连接失败，请检查网络设置",
  "error.server": "服务器错误，请稍后重试",
  "error.validation": "数据验证失败，请检查输入",
  "error.notFound": "未找到相关数据",
  "error.unauthorized": "没有访问权限",
  "error.forbidden": "操作被禁止",
  "error.internal": "服务器内部错误，请稍后重试。",
  "error.timeout": "请求超时，请重试",
  "error.unknown": "未知错误",
  "error.futureDate": "Onfleet API 不支持未来的起始日期。请选择今天或历史日期作为查询范围的开始时间。",
  "error.appError": "应用程序出现错误",
  "error.appErrorMessage": "抱歉，应用程序遇到了一个错误。请尝试刷新页面。",
  "error.errorDetails": "错误详情（开发模式）",
  "error.loadFailed": "加载失败",
  "error.saveFailed": "保存失败",
  "error.code.VALIDATION_FAILED": "校验失败，请检查输入。",
  "error.code.UNAUTHORIZED": "登录状态已过期，请重新登录。",
  "error.code.FORBIDDEN": "您没有执行此操作的权限。",
  "error.code.NOT_FOUND": "未找到请求的资源。",
  "error.code.METHOD_NOT_ALLOWED": "不允许此操作。",
  "error.code.CONFLICT": "与当前状态冲突，请刷新后重试。",
  "error.code.LOCKED": "该资源正被其他操作锁定，请稍后重试。",
  "error.code.RATE_LIMITED": "请求过于频繁，请稍后再试。",
  "error.code.REQUEST_FAILED": "请求无法完成。",
  "error.code.INTERNAL": "服务器出现问题，请稍后重试。",
  "error.code.ONFLEET_OUTBOUND_FAILED": "配送服务商拒绝了该请求。",
  "error.code.REPLAY_PAYLOAD_UNAVAILABLE": "原始 webhook 数据已不可用，无法重放。",
  "error.code.MAINTENANCE": "系统维护中，请几分钟后再试。",
  "success.save": "保存成功",
  "success.delete": "删除成功",
  "success.export": "导出成功",
  "success.update": "更新成功",
  "success.upload": "上传成功",
  "table.rows": "条记录",
  "table.page": "页",
  "table.of": "共",
  "table.showing": "显示第",
  "table.noResults": "暂无数据",
  "table.loadMore": "加载更多",
  "table.allDataLoaded": "已显示全部数据",
  "task.unassigned": "未分配",
  "task.assigned": "已分配",
  "task.active": "进行中",
  "task.completed": "已完成",
  "task.unknown": "未知",
  "task.refetch.sectionTitle": "从 Onfleet 重新拉取",
  "task.refetch.sectionDescription": "从 Onfleet 拉取该司机任务的最新状态并在本地重放。当怀疑某条 webhook 丢失时使用。",
  "task.refetch.button": "重新拉取 Onfleet 数据",
  "task.refetch.success.title": "拉取完成",
  "task.refetch.success.applied": "司机任务已从 Onfleet 刷新（状态：{{status}}）。",
  "task.refetch.success.stale": "Onfleet 没有比本地更新的状态，无需更新。",
  "task.refetch.success.terminal": "本地司机任务已处于终态（{{status}}），Onfleet 状态未被重放。",
  "task.refetch.success.illegal": "Onfleet 状态（{{to}}）不是本地状态（{{from}}）的合法迁移。本次拉取已跳过。",
  "task.refetch.error.title": "拉取失败",
  "task.refetch.error.notFound": "Onfleet 报告该司机任务不存在。可能已被删除或 id 错误。",
  "task.refetch.error.unknownTask": "Onfleet 中存在该司机任务，但 Fastcade 没有对应的配送单。可能是在系统外创建的司机任务。",
  "task.refetch.error.unknown": "无法访问 Onfleet。详情：{{detail}}",
  "worker.accepted": "已接受",
  "worker.invited": "已邀请",
  "worker.suspended": "已暂停",
  "auth.login.title": "登录",
  "auth.login.email": "工作邮箱",
  "auth.login.password": "密码",
  "auth.login.forgotPassword": "忘记密码？",
  "auth.login.submitting": "登录中...",
  "auth.login.submit": "登录",
  "auth.login.noAccount": "还没有账户？",
  "auth.login.signUp": "注册一个",
  "auth.login.emailNotVerified": "邮箱尚未验证，验证邮件已发送。",
  "auth.login.emailNotVerifiedHint": "请检查收件箱（及垃圾邮件文件夹）中的验证链接。",
  "auth.login.resendVerification": "重新发送验证邮件",
  "auth.login.resendingVerification": "发送中...",
  "auth.login.verificationResent": "验证邮件已发送！",
  "auth.login.heroTitle": "登录，把今天的配送日跑起来。",
  "auth.login.heroLead": "订单、备货清单、路线和司机，都在这里。",
  "auth.login.stationsLabel": "在 Fastcade 里的一个配送日",
  "auth.login.station.ordersIn": "订单进来",
  "auth.login.station.pickList": "备货清单",
  "auth.login.station.routes": "排线",
  "auth.login.station.driversOut": "司机出发",
  "auth.login.station.delivered": "送达",
  "auth.login.invalidCredentialsTitle": "邮箱和密码不匹配。",
  "auth.login.invalidCredentialsBody": "请检查后重试，或重设密码。",
  "auth.login.inviteOnly": "Fastcade 目前只接受邀请。请向店铺管理员索取邀请，或",
  "auth.login.requestAccess": "到 fastcade.com 申请使用。",
  "auth.login.requestAccessHref": "https://fastcade.com/zh/#access",
  "auth.shell.languageNav": "语言",
  "auth.shell.privacy": "隐私政策",
  "auth.shell.privacyHref": "https://fastcade.com/zh/privacy/",
  "auth.shell.terms": "服务条款",
  "auth.shell.termsHref": "https://fastcade.com/zh/terms/",
  "auth.forgot.title": "忘记密码",
  "auth.forgot.subtitle": "输入您的注册邮箱，我们将发送密码重置链接",
  "auth.forgot.email": "邮箱",
  "auth.forgot.submitting": "发送中...",
  "auth.forgot.submit": "发送重置链接",
  "auth.forgot.success": "邮件已发送",
  "auth.forgot.successMessage": "如果该邮箱已注册，您将收到一封密码重置邮件。请检查您的收件箱（以及垃圾邮件文件夹）。",
  "auth.forgot.backToLogin": "返回登录",
  "auth.reset.title": "重置密码",
  "auth.reset.subtitle": "请输入您的新密码",
  "auth.reset.newPassword": "新密码",
  "auth.reset.confirmPassword": "确认新密码",
  "auth.reset.submitting": "重置中...",
  "auth.reset.submit": "重置密码",
  "auth.reset.success": "密码已重置",
  "auth.reset.successMessage": "您的密码已成功重置，请使用新密码登录。",
  "auth.reset.goToLogin": "前往登录",
  "auth.reset.invalidLink": "链接无效",
  "auth.reset.invalidLinkMessage": "密码重置链接无效或缺少令牌。请重新申请密码重置。",
  "auth.reset.reapply": "重新申请",
  "auth.reset.passwordMismatch": "两次输入的密码不一致",
  "auth.reset.failedMessage": "密码重置失败，链接可能已过期。请重新申请。",
  "auth.reset.backToLogin": "返回登录",
  "auth.accept.title": "激活账号",
  "auth.accept.subtitle": "设置密码以完成 Fastcade 账号的开通",
  "auth.accept.password": "密码",
  "auth.accept.confirmPassword": "确认密码",
  "auth.accept.submit": "激活账号",
  "auth.accept.submitting": "正在激活…",
  "auth.accept.success": "账号已激活",
  "auth.accept.successMessage": "账号已就绪，请使用新密码登录。",
  "auth.accept.goToLogin": "前往登录",
  "auth.accept.invalidLink": "邀请链接无效",
  "auth.accept.invalidLinkMessage": "该链接缺少邀请令牌，请联系管理员重新发送邀请。",
  "auth.accept.passwordMismatch": "两次输入的密码不一致",
  "auth.accept.failedMessage": "无法激活账号，邀请可能已过期或已被使用。",
  "auth.accept.backToLogin": "返回登录",
  "auth.verify.title": "邮箱验证",
  "auth.verify.verifying": "正在验证您的邮箱，请稍候…",
  "auth.verify.success": "邮箱验证成功！您现在可以登录了。",
  "auth.verify.failed": "邮箱验证失败或链接已过期，请重新获取验证邮件。",
  "auth.verify.invalidLink": "链接无效：缺少验证令牌",
  "auth.verify.goToLogin": "前往登录",
  "auth.verify.backToLogin": "返回登录",
  "auth.invite.title": "创建账户",
  "auth.invite.subtitle": "设置登录信息，完成注册。",
  "auth.invite.email": "邮箱地址",
  "auth.invite.name": "姓名",
  "auth.invite.namePlaceholder": "请输入您的姓名",
  "auth.invite.password": "设置密码",
  "auth.invite.passwordPlaceholder": "请输入密码",
  "auth.invite.confirmPassword": "确认密码",
  "auth.invite.confirmPlaceholder": "请再次输入密码",
  "auth.invite.submitting": "提交中...",
  "auth.invite.submit": "完成注册",
  "auth.invite.success": "账户创建成功！请使用新密码登录",
  "auth.invite.successRedirect": "账户创建成功，正在跳转到登录页...",
  "auth.invite.failed": "注册失败",
  "auth.invite.emailRequired": "请输入邮箱地址",
  "auth.invite.nameRequired": "请输入姓名",
  "auth.invite.passwordMin": "密码长度至少为8位",
  "auth.invite.passwordMismatch": "两次输入的密码不一致",
  "auth.unauthorized.title": "无权访问",
  "auth.unauthorized.message": "您没有访问此页面所需的权限。",
  "auth.unauthorized.goHome": "返回首页",
  "auth.unauthorized.switchAccount": "切换账号",
  "password.strength": "密码强度",
  "password.strong": "强",
  "password.weak": "弱",
  "password.show": "显示密码",
  "password.hide": "隐藏密码",
  "password.minLength": "密码至少需要8位字符",
  "password.lowercase": "密码必须包含小写字母",
  "password.uppercase": "密码必须包含大写字母",
  "password.number": "密码必须包含数字",
  "password.special": "密码必须包含特殊字符（如 !@#$%^&* 等）",
  "privacy.title": "隐私通知",
  "privacy.message": "我们使用 cookies 和分析工具改善用户体验。这些工具收集匿名使用数据，不涉及个人身份信息。",
  "privacy.learnMore": "了解详情",
  "privacy.policyTitle": "隐私政策",
  "privacy.policyDetails": "我们只收集匿名使用统计\n不收集个人身份信息\n数据用于产品改进\n遵守GDPR规定\n您可随时撤销同意",
  "privacy.essential": "仅必要功能",
  "privacy.customize": "自定义设置",
  "privacy.acceptAll": "接受全部",
  "privacy.settingsTitle": "数据收集设置",
  "privacy.settingsMessage": "您希望允许我们收集匿名使用数据以改进产品吗？\n\n我们承诺：\n只收集匿名使用统计\n不收集个人身份信息\n不与第三方共享数据\n遵守 GDPR 隐私规定",
  "privacy.allowCollection": "允许数据收集",
  "privacy.decline": "拒绝",
  "query.editCondition": "编辑筛选条件",
  "query.done": "完成",
  "query.delete": "删除",
  "theme.light": "切换为浅色模式",
  "theme.dark": "切换为深色模式",
  "resource.changeHistory": "变更历史",
  "customer.label": "客户",
  "customer.field.shopifyId": "Shopify ID",
  "customer.field.email": "邮箱",
  "customer.field.verifiedEmail": "已验证",
  "customer.field.firstName": "名",
  "customer.field.lastName": "姓",
  "customer.field.phone": "电话",
  "customer.field.ordersCount": "订单数",
  "customer.field.lastOrderName": "最近订单",
  "customer.field.lastOrderId": "最近订单 ID",
  "customer.field.totalSpent": "总消费",
  "customer.field.currency": "货币",
  "customer.field.createdAt": "注册时间",
  "customer.field.state": "状态",
  "customer.field.acceptsMarketing": "接受营销",
  "customer.field.taxExempt": "免税",
  "customer.field.addresses": "地址",
  "customer.field.tags": "标签",
  "customer.field.note": "备注",
  "customer.field.source": "来源",
  "customer.field.receivedAt": "接收时间",
  "customer.group.contact": "联系信息",
  "customer.group.stats": "概览",
  "customer.group.meta": "元数据",
  "customer.enum.enabled": "已开通账户",
  "customer.enum.disabled": "未开通账户",
  "customer.enum.invited": "已邀请",
  "customer.enum.declined": "已拒绝邀请",
  "customer.searchPlaceholder": "按名称、邮箱或电话搜索客户...",
  "customer.detail.fallbackName": "客户",
  "customer.detail.subtitle": "Shopify ID: {{id}}",
  "customer.orders.sectionTitle": "近期订单",
  "customer.orders.count": "（已显示 {{count}} 条）",
  "customer.orders.countTruncated": "（仅显示前 {{count}} 条，实际更多）",
  "customer.orders.empty": "暂无订单。",
  "customer.orders.truncatedHint": "该客户订单超过 50 条。请前往订单页面，按客户 ID 筛选以查看全部历史。",
  "order.label": "订单",
  "order.field.name": "订单号",
  "order.field.email": "客户",
  "order.field.totalPrice": "总计",
  "order.field.currency": "货币",
  "order.field.financialStatus": "支付状态",
  "order.field.fulfillmentStatus": "配送状态",
  "order.field.lineItems": "商品",
  "order.field.shippingLines": "运输方式",
  "order.field.onfleetTaskCount": "Onfleet",
  "order.field.shippingAddress": "收货地址",
  "order.field.billingAddress": "账单地址",
  "order.field.processedAt": "日期",
  "order.field.deliveryDate": "送货日期",
  "order.field.receivedAt": "接收时间",
  "order.field.cancelledAt": "取消时间",
  "order.field.cancelReason": "取消原因",
  "order.field.closedAt": "关闭时间",
  "order.field.discountCodes": "优惠码",
  "order.field.taxLines": "税费",
  "order.field.note": "备注",
  "order.field.noteAttributes": "备注属性",
  "order.field.tags": "标签",
  "order.field.gateway": "支付网关",
  "order.field.source": "来源",
  "order.field.shopifyId": "Shopify ID",
  "order.field.createdAt": "创建时间",
  "order.group.summary": "概要",
  "order.group.items": "商品",
  "lineItem.title": "商品",
  "lineItem.quantity": "数量",
  "lineItem.price": "单价",
  "lineItem.subtotal": "小计",
  "lineItem.empty": "无商品明细",
  "lineItem.rawData": "原始数据",
  "lineItem.jobQuantity": "本配送单数量",
  "order.group.more": "其他信息",
  "order.enum.paid": "已支付",
  "order.enum.pending": "待支付",
  "order.enum.refunded": "已退款",
  "order.enum.authorized": "已授权",
  "order.enum.partiallyPaid": "部分支付",
  "order.enum.partiallyRefunded": "部分退款",
  "order.enum.voided": "已作废",
  "order.enum.fulfilled": "已完成",
  "order.enum.partial": "部分完成",
  "order.enum.unfulfilled": "未完成",
  "order.searchPlaceholder": "按订单号、邮箱或客户搜索...",
  "order.detail.subtitle": "订单 #{{number}}",
  "order.refetch.sectionTitle": "从 Shopify 重新拉取",
  "order.refetch.sectionDescription": "从 Shopify 拉取该订单的最新状态并在本地重放。当怀疑某条 webhook 丢失时使用。",
  "order.refetch.button": "重新拉取 Shopify 数据",
  "order.refetch.success.title": "拉取完成",
  "order.refetch.success.applied": "订单已从 Shopify 刷新（更新时间：{{updatedAt}}）。",
  "order.refetch.success.stale": "Shopify 没有比本地更新的状态，无需更新。",
  "order.refetch.success.projectionOnlyHint": "此操作仅重新同步订单数据；不会创建或更新司机任务（配送单只由实时 webhook 驱动）。",
  "order.refetch.error.title": "拉取失败",
  "order.refetch.error.notFound": "Shopify 找不到该订单。可能已被删除或订单 ID 不正确。",
  "order.refetch.error.unknown": "无法访问 Shopify。详情：{{detail}}",
  "order.trace.sectionTitle": "调用链",
  "order.trace.sectionDescription": "按时间排序的订单数据流：收到的 webhook、订单投影写入、webhook 失败、审计的运营操作、配送单（拆单）、Onfleet 派单。点击事件可查看原始字段。",
  "order.trace.loading": "正在加载调用链…",
  "order.trace.empty": "暂无调用链事件。",
  "order.trace.notFound": "调用链不可用——本地镜像中找不到该订单。",
  "order.trace.errorLoad": "加载调用链失败。详情：{{detail}}",
  "order.trace.summary": "事件 {{events}} 条 · trace id {{traces}} 个",
  "order.trace.cancelled": "已取消",
  "order.trace.payloadLabel": "原始报文",
  "order.trace.payloadTruncated": "报文已截断（超过 64KB）——仅显示前段字节。",
  "order.trace.showDetails": "查看详情",
  "order.trace.hideDetails": "收起详情",
  "order.trace.kind.webhookReceived": "Webhook",
  "order.trace.kind.orderProjected": "订单投影",
  "order.trace.kind.webhookFailure": "Webhook 失败",
  "order.trace.kind.operatorAction": "运营操作",
  "order.trace.kind.fulfillmentJob": "配送单",
  "order.trace.kind.onfleetTask": "司机任务",
  "order.trace.kind.unknown": "未知事件",
  "reviewQueue.pageTitle": "运营收件箱",
  "reviewQueue.tab.pending": "待处理",
  "reviewQueue.tab.history": "历史",
  "reviewQueue.group.main": "概览",
  "reviewQueue.totalUnresolved": "未处理条目总数",
  "reviewQueue.refresh": "刷新",
  "reviewQueue.loading": "正在加载条目…",
  "reviewQueue.errorLoad": "无法加载运营收件箱。详情：{{detail}}",
  "reviewQueue.empty": "收件箱已清空——暂无未处理条目。",
  "reviewQueue.kind.post_cutoff_order_change": "切单后订单变更",
  "reviewQueue.kind.unknown_onfleet_task": "未知司机任务",
  "reviewQueue.kind.webhook_failure_persistent": "持续 webhook 失败",
  "reviewQueue.kind.manual_refetch_needed": "需要手动 refetch",
  "reviewQueue.kind.post_dispatch_cancellation": "派单后取消",
  "reviewQueue.kind.dispatch_failed": "派单失败",
  "reviewQueue.cause.shopify_cancellation_after_dispatch": "派单后取消",
  "reviewQueue.cause.order_refunded_after_dispatch": "派单后全额退款",
  "reviewQueue.cause.quantity_changed_after_dispatch": "派单后改量",
  "reviewQueue.cause.address_changed_after_dispatch": "派单后改址",
  "reviewQueue.summary.post_cutoff_order_change": "订单 {{orderId}} 切单后变更——请核对 Onfleet 内容",
  "reviewQueue.summary.post_dispatch_cancellation": "订单 {{orderId}} — {{cause}}",
  "reviewQueue.summary.dispatch_failed": "订单 {{orderId}} — 派单失败（{{errorKind}}）",
  "reviewQueue.summaryCause.shopify_cancellation_after_dispatch": "取消发生在派单之后",
  "reviewQueue.summaryCause.quantity_changed_after_dispatch": "派单后改量——Onfleet 内容已过期",
  "reviewQueue.summaryCause.address_changed_after_dispatch": "派单后改址——司机正前往旧地址",
  "reviewQueue.errorKind.provider_rejected": "服务方拒绝了请求",
  "reviewQueue.errorKind.provider_unreachable": "服务方不可达",
  "reviewQueue.errorKind.unexpected": "未知失败",
  "reviewQueue.col.kind": "类型",
  "reviewQueue.col.summary": "摘要",
  "reviewQueue.col.createdAt": "创建时间",
  "reviewQueue.col.actions": "操作",
  "reviewQueue.row.resolve": "处理",
  "reviewQueue.row.confirmResolve": "确认",
  "reviewQueue.row.notePlaceholder": "处理备注（可选）",
  "reviewQueue.row.noteLabel": "处理备注",
  "reviewQueue.row.traceLabel": "trace：{{traceId}}",
  "reviewQueue.detail.title": "条目详情",
  "reviewQueue.detail.kind": "类型",
  "reviewQueue.detail.traceId": "追踪 ID",
  "reviewQueue.detail.createdAt": "创建时间",
  "reviewQueue.detail.noPayload": "该条目没有详情负载。",
  "reviewQueue.detail.payload": "详情负载",
  "reviewQueue.detail.handling": "处理指引",
  "reviewQueue.detail.guidance": "该怎么处理",
  "reviewQueue.detail.currentContents": "订单当前内容",
  "reviewQueue.detail.currentContentsHint": "这是订单现在的内容——请照它去核对司机任务，而不是照这条消息。",
  "reviewQueue.detail.contentsUnavailable": "这条消息背后的订单读取不到，因此不显示当前内容。",
  "reviewQueue.col.item": "商品",
  "reviewQueue.col.qty": "数量",
  "reviewQueue.guidance.quantity_changed_after_dispatch": "订单在派单之后才改的量，所以司机身上带的是旧内容。请到 Onfleet 打开该司机任务，按下方「订单当前内容」改正；若已来不及改变实际送出的东西，请联系客户，并在下方选择对应的补偿方式。",
  "reviewQueue.guidance.address_changed_after_dispatch": "订单在派单之后才改的地址，司机正前往旧地址。请立刻到 Onfleet 修改该司机任务的目的地；若司机已到达或已送达，请先联系客户再选择处理方式。",
  "reviewQueue.guidance.shopify_cancellation_after_dispatch": "客户在派单之后取消了订单，也就是说正在为一个已不存在的订单送货。请到 Onfleet 取消该司机任务；若已来不及拦下，请在下方决定补偿方式。",
  "reviewQueue.guidance.order_refunded_after_dispatch": "订单在派单之后被全额退款。若尚未送达，请到 Onfleet 取消该司机任务；然后按客户实际收到的东西选择对应的处理方式。",
  "reviewQueue.guidance.post_cutoff_order_change": "订单在打包切单之后发生了变更，厨房已打包的内容可能与它不再一致。请用下方「订单当前内容」核对已打包的东西，不一致就到 Onfleet 更新司机任务。",
  "reviewQueue.guidance.dispatch_failed": "向 Onfleet 派单失败，这个订单很可能根本没有司机任务。请到 Onfleet 确认：若司机任务从未创建，可从配送单重试派单，或手动创建司机任务，并在下方如实记录你用了哪种方式。",
  "reviewQueue.guidance.fallback": "这条消息暂无处理指引。请打开关联的订单与司机任务，判断客户需要什么，并在下方记录。",
  "reviewQueue.detail.relatedEntities": "相关实体",
  "reviewQueue.detail.relatedOrder": "订单",
  "reviewQueue.detail.relatedJob": "配送单",
  "reviewQueue.detail.relatedOnfleetTask": "司机任务",
  "reviewQueue.row.resolutionLabel": "处理方式",
  "reviewQueue.row.resolutionPlaceholder": "选择处理方式…",
  "reviewQueue.resolveOption.post_cutoff_order_change.no_change_needed": "无客户影响——按知会关闭",
  "reviewQueue.resolveOption.post_cutoff_order_change.contents_updated": "已更新 Onfleet 内容以匹配新订单",
  "reviewQueue.resolveOption.post_cutoff_order_change.contacted_customer": "已联系客户确认变更",
  "reviewQueue.resolveOption.post_dispatch_cancellation.comp_full": "全单补偿（退款 + 致歉）",
  "reviewQueue.resolveOption.post_dispatch_cancellation.comp_partial": "仅补偿受影响商品",
  "reviewQueue.resolveOption.post_dispatch_cancellation.chase_customer": "联系客户确认处理方式",
  "reviewQueue.resolveOption.post_dispatch_cancellation.no_action_needed": "无客户影响——按知会关闭",
  "reviewQueue.resolveOption.dispatch_failed.retried_ok": "已重试派单——司机任务已创建",
  "reviewQueue.resolveOption.dispatch_failed.dispatched_manually": "已手动创建司机任务",
  "reviewQueue.resolveOption.dispatch_failed.no_action_needed": "无需处理——订单不配送",
  "reviewQueue.resolveOption.acknowledged_legacy": "确认历史遗留项",
  "reviewQueue.prevPage": "上一页",
  "reviewQueue.nextPage": "下一页",
  "reviewQueue.paginationFooter": "显示 {{from}}–{{to}}，共 {{total}}",
  "reviewQueue.resolve.success.title": "已处理",
  "reviewQueue.resolve.success.single": "条目已移出收件箱。",
  "reviewQueue.resolve.error.title": "无法处理",
  "reviewQueue.resolve.error.alreadyResolved": "其他运营人员已处理此项。",
  "reviewQueue.resolve.error.unknown": "处理失败。详情：{{detail}}",
  "webhookFailures.pageTitle": "Webhook 失败队列",
  "webhookFailures.totalUnresolved": "未处理失败总数",
  "webhookFailures.loading": "加载失败记录中…",
  "webhookFailures.errorLoad": "无法加载 webhook 失败记录。详情：{{detail}}",
  "webhookFailures.empty": "暂无未处理的 webhook 失败。",
  "webhookFailures.provider.shopify": "Shopify",
  "webhookFailures.provider.onfleet": "Onfleet",
  "webhookFailures.errorKind.signature_verify_failed": "签名校验失败",
  "webhookFailures.errorKind.schema_parse_failed": "结构解析失败",
  "webhookFailures.errorKind.d1_write_failed": "本地数据库写入失败",
  "webhookFailures.errorKind.repo_write_failed": "数据库写入失败",
  "webhookFailures.errorKind.use_case_threw": "业务用例异常",
  "webhookFailures.errorKind.idempotency_replay_mismatch": "幂等重放不一致",
  "webhookFailures.errorKind.secret_misconfigured": "签名密钥未配置",
  "webhookFailures.errorKind.topic_not_owned": "未注册的 Topic",
  "webhookFailures.errorKind.race_deleted_job": "竞态：配送单已删除",
  "webhookFailures.col.provider": "服务方",
  "webhookFailures.col.topic": "Topic",
  "webhookFailures.col.errorKind": "错误类别",
  "webhookFailures.col.errorMessage": "错误信息",
  "webhookFailures.col.receivedAt": "接收时间",
  "webhookFailures.col.createdAt": "创建时间",
  "webhookFailures.col.resolved": "已解决",
  "webhookFailures.col.actions": "操作",
  "webhookFailures.row.resolve": "标记已处理",
  "webhookFailures.row.replay": "重放",
  "webhookFailures.row.traceLabel": "trace：{{traceId}}",
  "webhookFailures.replay.title": "重放",
  "webhookFailures.replay.errorTitle": "重放失败",
  "webhookFailures.replay.outcome.resolved": "已重放并处理——webhook 重新处理成功。",
  "webhookFailures.replay.outcome.duplicate": "已重放——该事件此前已处理（重复），失败记录已关闭。",
  "webhookFailures.replay.outcome.replayed": "已通过实时核心重放，失败记录已关闭。",
  "webhookFailures.replay.outcome.payloadUnavailable": "该失败没有存储载荷，无法重放。",
  "webhookFailures.replay.outcome.alreadyResolved": "其他运营人员已处理此失败。",
  "webhookFailures.replay.outcome.stillBroken": "重放已执行，但载荷契约仍然损坏。",
  "webhookFailures.replay.outcome.stillFailing": "重放已执行，但 webhook 仍然失败——可重试。",
  "webhookFailures.replay.outcome.notFound": "找不到该 id 的失败记录。",
  "webhookFailures.replay.outcome.unknown": "重放失败。详情：{{detail}}",
  "webhookFailures.selectAllOnPage": "选中本页全部失败记录",
  "webhookFailures.selectRow": "选中失败记录 {{id}}",
  "webhookFailures.prevPage": "上一页",
  "webhookFailures.nextPage": "下一页",
  "webhookFailures.paginationFooter": "显示第 {{from}}–{{to}} 条，共 {{total}} 条",
  "webhookFailures.bulkResolve.selectedCount": "已选 {{count}} 项",
  "webhookFailures.bulkResolve.submit": "标记所选为已处理",
  "webhookFailures.bulkResolve.clear": "清除选择",
  "webhookFailures.bulkResolve.success.title": "批量处理完成",
  "webhookFailures.bulkResolve.success.summary": "已处理 {{resolved}}；其中 {{alreadyResolved}} 已先行处理；{{notFound}} 未找到。",
  "webhookFailures.bulkResolve.error.title": "批量处理失败",
  "webhookFailures.bulkResolve.error.unknown": "无法处理所选失败记录。详情：{{detail}}",
  "webhookFailures.resolve.success.title": "已处理",
  "webhookFailures.resolve.success.single": "该失败记录已移出收件箱。",
  "webhookFailures.resolve.error.title": "无法处理",
  "webhookFailures.resolve.error.alreadyResolved": "其他运营人员已处理此失败。",
  "webhookFailures.resolve.error.unknown": "处理失败。详情：{{detail}}",
  "error.order.notFound": "订单不存在。",
  "order.recentTasks": "近期配送单",
  "order.noTasks": "暂无配送单",
  "order.noCustomer": "无客户信息",
  "order.customerDefaultAddress": "客户默认地址",
  "order.customer.title": "客户",
  "order.customer.viewProfile": "查看客户详情",
  "order.customer.guest": "游客下单",
  "order.customer.email": "邮箱",
  "order.customer.phone": "电话",
  "order.customer.ordersCount": "订单数",
  "order.customer.totalSpent": "消费总额",
  "order.customer.tags": "标签",
  "order.customer.address": "默认地址",
  "order.customer.note": "备注",
  "order.customer.unnamed": "未命名客户",
  "order.customer.noContact": "无联系方式",
  "order.customer.loadError": "加载客户信息失败",
  "order.bag": "袋号: {{number}}",
  "order.moreItems": "还有 {{count}} 条，查看详情",
  "order.onfleetCount": "Onfleet ({{count}})",
  "product.label": "产品",
  "product.field.shopifyId": "Shopify ID",
  "product.field.title": "产品名称",
  "product.field.bodyHtml": "描述",
  "product.field.productType": "类型",
  "product.field.status": "状态",
  "product.field.options": "选项",
  "product.field.variants": "变体",
  "product.field.images": "图片",
  "product.field.vendor": "供应商",
  "product.field.publishedAt": "发布时间",
  "product.field.createdAt": "创建时间",
  "product.field.handle": "URL 别名",
  "product.field.tags": "标签",
  "product.field.seoTitle": "SEO 标题",
  "product.field.seoDescription": "SEO 描述",
  "product.field.source": "来源",
  "product.field.receivedAt": "接收时间",
  "product.group.main": "概览",
  "product.group.meta": "元数据",
  "product.group.details": "详情",
  "product.enum.active": "上架",
  "product.enum.draft": "草稿",
  "product.enum.archived": "已归档",
  "product.enum.unlisted": "不公开",
  "product.detail.subtitle": "Shopify ID: {{id}}",
  "product.seo.preview": "SEO 预览",
  "product.seo.noDescription": "暂无描述",
  "product.seo.metadata": "元数据",
  "product.seo.created": "创建时间",
  "product.seo.updated": "更新时间",
  "product.field.shippingDate": "发货日期",
  "product.shippingDateSource.metafield": "元数据",
  "product.shippingDateSource.title": "标题",
  "product.shippingDateSource.manual": "手动",
  "product.field.metafields": "自定义元数据",
  "product.options.primary": "主要选项",
  "product.options.values": "选项值",
  "driver.label": "司机",
  "driver.field.onfleetId": "Onfleet ID",
  "driver.field.name": "姓名",
  "driver.field.displayName": "司机信息",
  "driver.field.phone": "电话",
  "driver.field.email": "邮箱",
  "driver.field.vehicle": "车辆",
  "driver.field.active": "在线",
  "driver.field.tasks": "进行中司机任务",
  "driver.field.isOnDuty": "值班状态",
  "driver.field.hasTasks": "有司机任务",
  "driver.field.lastActivity": "最后活动",
  "driver.field.createdAt": "创建时间",
  "driver.group.main": "司机",
  "driver.group.tasks": "司机任务",
  "driver.group.meta": "元数据",
  "driver.searchPlaceholder": "搜索司机...",
  "driver.detail.subtitle": "电话: {{phone}}",
  "driver.unknownDriver": "未知司机",
  "driver.taskCount_one": "{{count}} 个司机任务",
  "driver.taskCount_other": "{{count}} 个司机任务",
  "driver.noTasks": "暂无司机任务",
  "driver.onDuty": "值班中",
  "driver.offDuty": "已下班",
  "driver.status": "状态: {{status}}",
  "job.label": "配送单",
  "job.field.id": "配送单 ID",
  "job.field.name": "名称",
  "job.unnamed": "未命名",
  "job.field.orderId": "订单",
  "job.field.deliveryDate": "配送日期",
  "job.field.shippingDate": "配送日期(配送单)",
  "job.field.status": "状态",
  "job.field.onfleetTaskId": "司机任务",
  "job.field.onfleetTaskShortId": "司机任务短号",
  "job.field.shopifyFulfillmentId": "Shopify 配送记录",
  "job.field.customerName": "客户姓名",
  "job.field.customerPhone": "电话",
  "job.field.deliveryAddress": "配送地址",
  "job.field.taskNote": "司机任务详情",
  "job.field.orderNote": "客户备注",
  "job.field.operatorNote": "运营备注",
  "job.field.originalAddress": "原始地址",
  "job.field.attempt": "尝试次数",
  "job.field.lastError": "最近错误",
  "job.field.lineItemsJson": "订单商品（标出本配送单数量）",
  "job.field.dispatchSnapshotJson": "派单快照",
  "job.field.completionIdempotencyKey": "幂等键",
  "job.field.batchSignature": "批次签名",
  "job.field.createdAt": "创建时间",
  "job.field.updatedAt": "更新时间",
  "job.group.main": "配送单",
  "job.group.customer": "客户",
  "job.group.data": "商品",
  "job.section.basic": "基本信息",
  "job.section.driver": "司机与 Shopify",
  "job.section.recipient": "收货人",
  "job.section.notes": "备注",
  "job.section.record": "记录信息",
  "address.opensMaps": "（在 Google 地图中打开）",
  "address.copy": "复制地址",
  "address.copied": "地址已复制",
  "job.progress.inWindow": "在送达时段 {{start}}–{{end}} 内",
  "job.progress.ahead_one": "前面还有 {{count}} 单",
  "job.progress.ahead_other": "前面还有 {{count}} 单",
  "job.progress.active": "正在送这一单",
  "job.progress.lateBy": "比 {{end}} 晚 {{minutes}} 分钟",
  "job.progress.delivered": "已送达",
  "job.progress.deliveredAt": "已送达 {{time}}",
  "job.progress.deliveredBy": "{{name}} 送达",
  "job.progress.notYet": "配送日 {{date}}。出发后才有预计送达时间。",
  "job.progress.unavailable": "配送平台暂时没有返回预计时间。司机：{{name}}",
  "job.progress.closed": "这单不在配送中，没有预计送达时间。",
  "job.enum.planned": "已计划",
  "job.enum.dispatched": "已派单",
  "job.enum.in_progress": "配送中",
  "job.enum.completed": "已完成",
  "job.enum.cancelled": "已取消",
  "job.enum.exception": "异常",
  "job.searchPlaceholder": "按订单号、客户姓名、电话、司机任务短号、商品或备注搜索…",
  "job.preset.today": "今日",
  "job.preset.tomorrow": "明日",
  "job.preset.pastDate": "过期",
  "job.preset.pastDateCount_one": "，{{count}} 条过期配送单",
  "job.preset.pastDateCount_other": "，{{count}} 条过期配送单",
  "job.today.title": "今日配送 · {{day}}",
  "job.today.progressLabel": "今日配送进度",
  "job.today.unavailable": "今日计数暂不可用",
  "job.bulk.schedule.label": "派出",
  "job.bulk.schedule.confirm.title_one": "立即派出所选 {{count}} 张配送单？",
  "job.bulk.schedule.confirm.title_other": "立即派出所选 {{count}} 张配送单？",
  "job.bulk.schedule.confirm.description": "为每张所选「待派单」配送单逐张创建司机任务——与详情页「立即派单」相同的命令。",
  "job.bulk.schedule.result": "已派单 {{dispatched}} 张，失败 {{failed}} 张",
  "job.bulk.schedule.disabledReason": "仅「待派单」状态的配送单可立即派单——请取消选择其他状态的行。",
  "job.bulk.cancel.label": "取消",
  "job.bulk.cancel.confirm.title_one": "取消所选 {{count}} 张配送单？",
  "job.bulk.cancel.confirm.title_other": "取消所选 {{count}} 张配送单？",
  "job.bulk.cancel.confirm.description": "「已计划」的配送单直接取消。「已派单」的配送单先删除配送平台上的司机任务，再取消配送单；司机已接单的不会取消，需在配送平台上人工处理。此操作不可撤销。",
  "job.bulk.cancel.confirm.keep": "保留配送单",
  "job.bulk.cancel.disabledReason": "仅「已计划」或「已派单」的配送单可取消——请取消选择其他状态的行。",
  "job.bulk.cancel.result": "已取消 {{cancelled}} 张，司机已接单未取消 {{assigned}} 张，失败 {{failed}} 张",
  "job.detail.title": "配送单 {{label}}",
  "job.searchHit.otherDate": "命中的是 {{dates}} 配送日的商品明细",
  "job.searchHit.otherDateHint": "本配送单被搜索命中，是因为同一订单在另一个配送日的商品明细含有搜索词。",
  "job.orderLabel": "{{name}} · {{date}}",
  "job.detail.subtitle": "{{status}} — {{date}}",
  "job.detail.noDate": "暂无日期",
  "job.actions.more": "更多操作",
  "job.actions.scheduleNow": "立即派单",
  "job.actions.reschedule": "改期",
  "job.actions.cancel": "取消配送单",
  "job.actions.refetch": "重新拉取",
  "job.actions.cancelDispatched": "取消派单",
  "job.actions.success": "操作成功",
  "job.actions.note.edit": "编辑备注",
  "job.actions.note.dialogTitle": "运营备注",
  "job.actions.note.dialogSubtitle": "保存此配送单的配送说明；仅在配送平台创建司机任务时发送。",
  "job.actions.note.label": "备注",
  "job.actions.note.placeholder": "添加配送说明",
  "job.actions.note.save": "保存备注",
  "job.actions.note.success": "运营备注已保存",
  "job.actions.error.title": "操作失败",
  "job.actions.error.generic": "操作未能完成，请稍后重试。",
  "job.actions.error.onfleetTaskAssigned": "司机已接单，无法自动取消，请在配送平台上人工处理。",
  "job.actions.confirm.schedule.title": "立即派出该配送单？",
  "job.actions.confirm.schedule.message": "将立即为该配送单创建司机任务。",
  "job.actions.confirm.cancel.title": "取消该配送单？",
  "job.actions.confirm.cancel.message": "将取消该待派单配送单，此操作不可撤销。",
  "job.actions.confirm.cancelDispatched.title": "取消派单？",
  "job.actions.confirm.cancelDispatched.message": "将拆除对应的司机任务并把配送单撤回，此操作不可撤销。",
  "job.actions.reschedule.dialogTitle": "配送单改期",
  "job.actions.reschedule.dialogSubtitle": "将该待派单配送单移动到新的配送日期。",
  "job.actions.reschedule.dateLabel": "新配送日期",
  "job.actions.reschedule.dateRequired": "请选择配送日期。",
  "job.actions.reschedule.submit": "改期",
  "job.unresolvedOrder": "无法解析订单",
  "job.unresolvedOrderTooltip": "无法解析订单名称",
  "webhook.title": "Webhook 事件",
  "webhook.group.main": "概览",
  "webhook.searchPlaceholder": "按主题 / 提供方 / 状态 / 时间筛选 webhook…",
  "webhook.field.id": "ID",
  "webhook.field.provider": "提供方",
  "webhook.field.tenantId": "租户",
  "webhook.field.traceId": "追踪",
  "webhook.field.apiVersion": "API 版本",
  "webhook.field.providerEventId": "提供方事件 ID",
  "webhook.field.providerEmittedAt": "发出时间",
  "webhook.field.lastAttemptAt": "最后尝试时间",
  "webhook.field.completedAt": "完成时间",
  "webhook.field.source": "来源",
  "webhook.field.topic": "主题",
  "webhook.field.eventKey": "事件 Key",
  "webhook.field.status": "状态",
  "webhook.field.error": "错误",
  "webhook.field.receivedAt": "接收时间",
  "webhook.field.processedAt": "处理时间",
  "webhook.field.payload": "载荷",
  "webhook.field.headers": "请求头",
  "webhook.field.payloadHash": "载荷哈希",
  "webhook.enum.shopify": "Shopify",
  "webhook.enum.onfleet": "Onfleet",
  "webhook.enum.received": "已接收",
  "webhook.enum.completed": "已完成",
  "webhook.enum.unknownProvider": "未知提供方: {{provider}}",
  "webhook.enum.pending": "处理中",
  "webhook.enum.success": "成功",
  "webhook.enum.failed": "失败",
  "webhook.enum.retrying": "重试中",
  "webhook.group.timing": "时间信息",
  "webhook.group.content": "内容",
  "webhook.payload.title": "原始负载",
  "webhook.payload.loading": "正在加载负载…",
  "webhook.payload.loadError": "加载负载失败：{{detail}}",
  "webhook.payload.thinned": "原始负载已被保留策略清除，不再可用。",
  "webhook.recovery.title": "恢复",
  "webhook.recovery.description": "把这条投递重新送入实时摄取核心。当事件到达很久之后仍停在「已接收」时使用——数据库过载会让投递搁浅且不留失败记录。",
  "webhook.recovery.replay": "重放",
  "webhook.recovery.replaying": "正在重放…",
  "webhook.recovery.notStuck": "这里只能重放仍处于「已接收」的事件。失败的事件请在 webhook 失败收件箱里重放。",
  "webhook.recovery.replayed": "已通过实时核心重放（结果：{{outcome}}）。",
  "webhook.recovery.replayError": "重放失败：{{detail}}",
  "profile.pageTitle": "用户资料",
  "profile.subtitle": "你的账号信息与登录方式。",
  "profile.accountDetails": "账户信息",
  "profile.accountDetailsDesc": "查看您的账户信息",
  "profile.accountId": "账户 ID",
  "profile.role": "角色",
  "profile.emailVerified": "邮箱验证",
  "profile.verified": "已验证",
  "profile.unverified": "未验证",
  "profile.lastUpdated": "最后更新",
  "profile.editProfile": "编辑资料",
  "profile.editProfileDesc": "更新您的个人信息",
  "profile.displayName": "显示名称",
  "profile.displayNamePlaceholder": "请输入您的姓名",
  "profile.emailLabel": "邮箱",
  "profile.emailManaged": "邮箱由管理员管理。",
  "profile.saveChanges": "保存更改",
  "profile.saving": "保存中...",
  "profile.updateSuccess": "资料更新成功",
  "profile.updateFailed": "资料更新失败",
  "profile.loadingProfile": "加载用户资料...",
  "profile.security": "安全设置",
  "profile.securityDesc": "管理您的密码和安全设置",
  "profile.passwordChanged": "密码修改成功，其他会话已全部注销。",
  "profile.passwordChangeFailed": "密码修改失败",
  "user.unknown": "未知用户",
  "users.title": "用户管理",
  "users.subtitle": "管理团队成员、角色和权限。",
  "users.inviteUser": "邀请用户",
  "users.inviteModalTitle": "邀请用户",
  "users.inviteModalDesc": "发送邀请邮件以加入系统。",
  "users.emailLabel": "邮箱",
  "users.emailPlaceholder": "user@example.com",
  "users.nameLabel": "姓名（选填）",
  "users.namePlaceholder": "张三",
  "users.roleLabel": "角色",
  "users.sending": "发送中...",
  "users.sendInvite": "发送邀请",
  "users.inviteFailed": "邀请失败",
  "users.invitationSent": "邀请已发送",
  "users.columnEmail": "邮箱",
  "users.columnName": "姓名",
  "users.columnRole": "角色",
  "users.columnStatus": "状态",
  "users.statusActive": "活跃",
  "users.noUsers": "暂无用户",
  "users.revokeInvitationFailed": "撤销邀请失败",
  "users.revokeInvitation": "撤销邀请",
  "users.revokeInvitationConfirm": "这会删除该被邀请账号及其待接受的邀请。已发出的链接立即失效，并会释放该邮箱地址，使其可以被重新邀请。此操作不可撤销。",
  "users.invitationRevoked": "邀请已撤销，该邮箱地址已释放。",
  "users.resendInvitation": "重新发送邀请",
  "users.invitationResent": "新邀请已发送，之前的链接已失效。",
  "users.invitation.title": "邀请待接受",
  "users.invitation.sentAt": "发出于",
  "users.invitation.expiresAt": "过期于",
  "users.invitation.expired": "已过期",
  "users.changeRole": "更改角色",
  "users.changeRoleTooltip": "更改角色",
  "users.roleUpdateFailed": "角色更新失败",
  "users.permissionsUpdateFailed": "权限更新失败",
  "users.error.self_role_change_forbidden": "不能修改自己的角色。",
  "users.error.last_admin_protected": "不能移除最后一位管理员。",
  "users.error.no_updatable_fields": "未提供可更新的字段。",
  "users.error.filter_conflict": "不能同时使用角色筛选与通用字段筛选，请择其一。",
  "users.error.search_missing_value": "设置了搜索字段或操作符后，必须同时提供搜索值。",
  "users.error.filter_missing_value": "设置了筛选字段或操作符后，必须同时提供筛选值。",
  "users.error.pagination_conflict": "分页只能使用 page 或 offset 之一，不可同时传。",
  "users.permRoleLabel": "角色",
  "users.permResourceCol": "资源",
  "users.dismiss": "关闭",
  "users.adminFullAccess": "管理员拥有全部权限，无法单独编辑。",
  "users.detail.backToList": "返回用户列表",
  "users.detail.profileTitle": "基础信息",
  "users.detail.emailHint": "邮箱由身份源管理，此处不可修改。",
  "users.detail.statusLabel": "状态",
  "users.detail.roleSectionTitle": "角色",
  "users.detail.saveRole": "保存角色",
  "users.detail.roleUpdated": "角色已更新",
  "users.detail.permissionsTitle": "生效权限",
  "users.detail.permissionsEmpty": "暂无权限",
  "users.detail.notFoundTitle": "未找到用户",
  "users.detail.notFoundDesc": "该用户不存在或已被删除。",
  "users.detail.loadFailed": "加载用户失败",
  "users.detail.lastLogin": "上次登录",
  "users.detail.lastLoginNever": "从未登录",
  "users.detail.createdAt": "创建时间",
  "perm.customized": "已自定义",
  "perm.resetToRole": "重置为默认",
  "perm.fetchFailed": "权限加载失败，显示角色默认权限",
  "dispatch.title": "物流配送",
  "dispatch.header.flowLabel": "流程：",
  "dispatch.header.flowBatch.shipping_date": "按配送日",
  "dispatch.header.flowStates_one": "{{count}} 个状态",
  "dispatch.header.flowStates_other": "{{count}} 个状态",
  "dispatch.header.flowSettings": "设置",
  "dispatch.header.range": "{{from}} – {{to}}",
  "dispatch.header.pickDate": "选择配送日",
  "dispatch.view.label": "视图",
  "dispatch.view.board": "批次看板",
  "dispatch.view.list": "列表",
  "dispatch.view.map": "地图",
  "dispatch.overview.runExplainer": "执行派单将为可派的配送单创建 Onfleet 司机任务；异常配送单需先处理。",
  "dispatch.consolidate.label": "按地址合并",
  "dispatch.dispatching": "派单中...",
  "dispatch.dispatchingProgress": "派单中...（已派出 {{dispatched}}）",
  "dispatch.runCard.gate": "{{batch}} · 派单 {{from}}–{{to}}",
  "dispatch.runCard.gateOtherDay": "{{batch}} · 派单 当天 {{from}}–{{to}}",
  "dispatch.runCard.gateCutoffOnly": "{{batch}} · 派单截止 {{at}}",
  "dispatch.runCard.gateCutoffOnlyOtherDay": "{{batch}} · 派单截止 当天 {{at}}",
  "dispatch.runCard.tasksUnit_one": "个司机任务",
  "dispatch.runCard.tasksUnit_other": "个司机任务",
  "dispatch.runCard.fromJobs_one": "来自 {{count}} 张配送单",
  "dispatch.runCard.fromJobs_other": "来自 {{count}} 张配送单",
  "dispatch.runCard.mergeNow_one": "现在 {{count}} 处同地址可合并",
  "dispatch.runCard.mergeNow_other": "现在 {{count}} 处同地址可合并",
  "dispatch.runCard.mergeOff": "一张配送单一个司机任务",
  "dispatch.runCard.timelinePackaging": "{{at}} 配送单打印截止",
  "dispatch.runCard.runBeforeCutoff": "现在派出（建议 {{at}} 后）",
  "dispatch.runCard.run": "派出",
  "dispatch.runCard.runEarly": "提前派出",
  "dispatch.runCard.note": "派出之后进来的同地址订单，下次派单时会单独派成一个新的司机任务，不会并进已经派出的司机任务。所以建议在配送单打印截止之后一次派完，同地址合并最多。",
  "dispatch.runCard.confirmTitle_one": "派出 {{batch}} 的 {{count}} 张配送单",
  "dispatch.runCard.confirmTitle_other": "派出 {{batch}} 的 {{count}} 张配送单",
  "dispatch.runCard.confirmJobs": "配送单",
  "dispatch.runCard.confirmTasks": "司机任务",
  "dispatch.runCard.confirmAnomalies": "预检异常",
  "dispatch.runCard.confirmNoteAnomalies_one": "还有 {{count}} 项预检异常：现在派，这一批派单会中途失败。先在左边取消那张配送单。",
  "dispatch.runCard.confirmNoteAnomalies_other": "还有 {{count}} 项预检异常：现在派，这一批派单会中途失败。先在左边取消那张配送单。",
  "dispatch.runCard.confirmNote": "将在 Onfleet 创建司机任务。之后进来的同地址订单会在下次派单时单独派成新的司机任务，不会并进这次的司机任务。",
  "dispatch.runCard.confirmRun": "派出",
  "dispatch.moreChecks.title": "更多核对",
  "dispatch.runProgressCount": "已处理 {{processed}} / 总计 {{total}}（剩余 {{remaining}}）",
  "dispatch.dayJobs": "当日配送单",
  "dispatch.dayJobsEmpty": "当日暂无配送单",
  "dispatch.eta.title": "路线预计送达",
  "dispatch.eta.asOf": "更新于 {{time}}",
  "dispatch.eta.empty": "当前没有进行中的路线。",
  "dispatch.eta.error": "无法加载路线预计送达时间。",
  "dispatch.eta.unknownOrder": "未标注站点",
  "dispatch.eta.state.assigned": "已分配",
  "dispatch.eta.state.active": "进行中",
  "dispatch.eta.state.completed": "已送达",
  "dispatch.eta.todayOnly": "实时数据 — 仅今日",
  "dispatch.eta.loading": "正在加载路线…",
  "dispatch.eta.pendingCount": "{{count}} 待完成",
  "dispatch.eta.completedCount": "{{count}} 已完成",
  "dispatch.eta.totalCount": "{{count}} 总计",
  "dispatch.eta.progress": "{{completed}}/{{total}}",
  "dispatch.eta.nextStopLabel": "下一站",
  "dispatch.eta.allDone": "已收尾",
  "dispatch.eta.latestEta": "末单 {{time}}",
  "dispatch.eta.noEta": "暂无预计",
  "dispatch.reconcileAll.running": "对账中…",
  "dispatch.reconcile.idle": "尚未核对——点上方「核对一次」运行。",
  "dispatch.delivered.kpi.delivered": "送达",
  "dispatch.delivered.kpi.ofTotal": "/ {{total}}",
  "dispatch.delivered.kpi.late": "晚于 {{at}}",
  "dispatch.delivered.kpi.lateHint": "按完成时间",
  "dispatch.delivered.kpi.writtenBack": "Shopify 配送记录已回写",
  "dispatch.delivered.kpi.writtenBackHint": "按配送单上的 Shopify 配送记录计；手动刷新补成送达的不会回写",
  "dispatch.delivered.reconcile.title": "对账",
  "dispatch.delivered.reconcile.runFirst": "核对一次",
  "dispatch.delivered.reconcile.runAgain": "再核对一次",
  "dispatch.delivered.reconcile.shopifySide": "Shopify 侧",
  "dispatch.delivered.reconcile.onfleetSide": "Onfleet 侧",
  "dispatch.delivered.reconcile.shopifyWhy": "需求与库存，对比 Shopify",
  "dispatch.delivered.reconcile.onfleetWhy": "配送单，对比 Onfleet 司机任务",
  "dispatch.delivered.reconcile.match": "一致",
  "dispatch.delivered.note.title": "这个批次",
  "dispatch.delivered.note.body": "送达后不需要动手。送达失败的会出现在「异常 / 取消」那一列。",
  "dispatch.reconcile.diffLabel_one": "差异",
  "dispatch.reconcile.diffLabel_other": "差异",
  "dispatch.reconcileCheck.notRun": "未核对",
  "dispatch.reconcileCheck.alertCount": "{{count}} 项{{label}}",
  "dispatch.reconcile.running": "正在运行对账…",
  "dispatch.reconcile.onfleetNotReady_one": "Onfleet 上尚无 {{date}} 的司机任务（共 {{count}} 张本地配送单待对账）。对方通常在配送日凌晨批量建司机任务，请稍后重跑对账。",
  "dispatch.reconcile.onfleetNotReady_other": "Onfleet 上尚无 {{date}} 的司机任务（共 {{count}} 张本地配送单待对账）。对方通常在配送日凌晨批量建司机任务，请稍后重跑对账。",
  "dispatch.reconcile.warning": "{{date}} 的本地配送单缺少 {{count}} 张。",
  "dispatch.reconcile.realDiffSummary_one": "{{date}} 有 {{count}} 项当日对账差异需要处理。",
  "dispatch.reconcile.realDiffSummary_other": "{{date}} 有 {{count}} 项当日对账差异需要处理。",
  "dispatch.reconcile.realDiffOrders": "订单",
  "dispatch.reconcile.more": "，另有 {{count}} 项",
  "dispatch.reconcile.backfillGuidance": "派单前，请按运行手册执行 materialize-backfill 操作（POST /api/fulfillment-jobs/materialize-backfill），然后重新运行对账。",
  "dispatch.reconcile.passed": "对账通过",
  "dispatch.reconcile.totals": "本地：{{ours}} · Onfleet：{{gas}}",
  "dispatch.reconcile.secondary": "Onfleet 缺少：{{missingGas}} · 配送单数不一致：{{diverged}}",
  "dispatch.reconcile.cancelledOurs": "本地已取消：{{count}}（Onfleet 建单后才退款/取消；GAS 侧遗留司机任务需人工取消）",
  "dispatch.reconcile.outOfBand": "Onfleet 带外司机任务：{{count}}（无对应 Shopify 订单，已知非缺陷）",
  "dispatch.reconcile.error": "对账检查失败：{{message}}",
  "dispatch.truthReconcile.running": "核对中…",
  "dispatch.truthReconcile.idle": "针对所选日期，把每个派单数字与 Shopify（真值来源）逐项核对。只读——不会写回。",
  "dispatch.truthReconcile.error": "真值核对失败：{{message}}",
  "dispatch.truthReconcile.empty": "该日期没有可对账的项目。",
  "dispatch.truthReconcile.emptyValue": "—",
  "dispatch.truthReconcile.summary": "漂移：{{drift}} · 疑似偏移：{{maybeSkew}} · 未知：{{unknown}}",
  "dispatch.truthReconcile.asOf": "Shopify 截至 {{shopifyAsOf}} · 本地截至 {{d1AsOf}}",
  "dispatch.truthReconcile.asOfShort": "截至 {{at}}",
  "dispatch.truthReconcile.coverageIncomplete": "覆盖不完整——部分记录无法比对，计数视为局部结果。",
  "dispatch.truthReconcile.oursLabel": "我方（本地记录）",
  "dispatch.truthReconcile.truthLabel": "真值（Shopify）",
  "dispatch.truthReconcile.method": "口径",
  "dispatch.truthReconcile.action": "建议动作",
  "dispatch.truthReconcile.evidence.show": "展开证据",
  "dispatch.truthReconcile.evidence.hide": "收起证据",
  "dispatch.truthReconcile.evidence.d1Rows": "本地记录行",
  "dispatch.truthReconcile.evidence.shopifyRaw": "Shopify 原件",
  "dispatch.truthReconcile.verdict.match": "一致",
  "dispatch.truthReconcile.verdict.drift": "漂移",
  "dispatch.truthReconcile.verdict.maybe_skew": "疑似偏移",
  "dispatch.truthReconcile.verdict.unknown": "未知",
  "dispatch.truthReconcile.tile.aria": "{{label}}：{{count}}",
  "dispatch.truthReconcile.allClear": "所有派单数字与 Shopify 一致——无漂移。",
  "dispatch.truthReconcile.noneInView": "该视图下没有项目。",
  "dispatch.salesBridge.title": "配送件数核对",
  "dispatch.salesBridge.description": "核对 {{date}} 的下单、退款与需配送件数。",
  "dispatch.salesBridge.loading": "正在加载…",
  "dispatch.salesBridge.error": "加载失败，请刷新重试。",
  "dispatch.salesBridge.empty": "该日期没有订单，也没有配送单。",
  "dispatch.salesBridge.productsTitle": "各商品下单件数",
  "dispatch.salesBridge.productsCount_one": "{{count}} 个商品",
  "dispatch.salesBridge.productsCount_other": "{{count}} 个商品",
  "dispatch.salesBridge.productsSoldOut": "{{count}} 项售罄",
  "dispatch.salesBridge.productCounts": "下单 {{units}} 件 · {{orders}} 个订单",
  "dispatch.salesBridge.multiQty_one": "{{count}} 个订单购买多件",
  "dispatch.salesBridge.multiQty_other": "{{count}} 个订单购买多件",
  "dispatch.salesBridge.exceptionsTitle": "已退款/取消，无需配送的订单",
  "dispatch.salesBridge.exceptionUnits_one": "不配送 {{count}} 件",
  "dispatch.salesBridge.exceptionUnits_other": "不配送 {{count}} 件",
  "dispatch.salesBridge.removedRefundInfo": "已退款，商品退回库存，未计入下单件数",
  "dispatch.salesBridge.missingJobsTitle": "以下订单尚无配送单",
  "dispatch.salesBridge.missingJobsEmpty": "所有订单都有配送单",
  "dispatch.salesBridge.exceptionsEmpty": "没有退款或取消的订单",
  "dispatch.salesBridge.unpaidTitle": "以下订单尚未收款",
  "dispatch.salesBridge.unpaidEmpty": "所有订单都已收款",
  "dispatch.salesBridge.alreadyPaid": "Shopify 已付款 · 本地滞后",
  "dispatch.salesBridge.alreadyPaidHint_one": "其中 {{count}} 单 Shopify 实际已付款（本地快照滞后）——跑「核对真值」确认。",
  "dispatch.salesBridge.alreadyPaidHint_other": "其中 {{count}} 单 Shopify 实际已付款（本地快照滞后）——跑「核对真值」确认。",
  "dispatch.salesBridge.multiQtyDetailTitle": "一单多件，打包时请核对",
  "dispatch.salesBridge.multiQtyDetailEmpty": "没有一单多件的订单",
  "dispatch.salesBridge.multiQtyDetailRow": "{{order_name}} · {{product_name}} ×{{quantity}}",
  "dispatch.salesBridge.zeroUnitTitle": "以下订单有配送单、但当日应送 0 件（不计入需配送）",
  "dispatch.salesBridge.zeroUnitEmpty": "没有 0 件订单",
  "dispatch.salesBridge.zeroUnitJobStatuses": "配送单状态：{{statuses}}",
  "dispatch.salesBridge.zeroUnitHint": "常见原因：送达后退款、或商品行被退款移除/改期。",
  "dispatch.salesBridge.jobStatusSeparator": "、",
  "dispatch.salesBridge.passed": "通过",
  "dispatch.salesBridge.needsConfirm": "{{count}} 项待确认",
  "dispatch.salesBridge.allPassed": "检查全部通过，可以排线",
  "dispatch.salesBridge.parseFailuresTitle_one": "{{count}} 个订单无法读取",
  "dispatch.salesBridge.parseFailuresTitle_other": "{{count}} 个订单无法读取",
  "dispatch.salesBridge.parseFailure.kind.malformed_json": "商品行数据格式错误",
  "dispatch.salesBridge.parseFailure.kind.schema_invalid": "商品行数据结构无效",
  "dispatch.salesBridge.parseFailure.kind.invalid_created_at": "创建日期无效",
  "dispatch.salesBridge.parseFailure.kind.missing_order": "缺少订单记录",
  "dispatch.salesBridge.parseFailure.kind.unknown": "未知解析错误",
  "dispatch.salesBridge.inventoryAvailable": "本地快照剩余可售 {{count}} 件",
  "dispatch.salesBridge.shopifyInventoryAvailable": "Shopify 实时可售 {{count}} 件",
  "dispatch.salesBridge.shopifyInventoryUntracked": "Shopify 实时库存：未跟踪",
  "dispatch.salesBridge.shopifyAsOf": "Shopify 菜单与库存截至 {{at}}",
  "dispatch.salesBridge.shopifyUnavailable": "Shopify 菜单与库存不可用：{{reason}}",
  "dispatch.salesBridge.anomaly.menuOnly": "仅 Shopify 菜单 · 本地订单为 0",
  "dispatch.salesBridge.anomaly.ordersOnly": "仅本地订单 · Shopify 菜单缺失",
  "dispatch.salesBridge.anomaly.inactiveUpcoming": "今日或未来商品未启用",
  "dispatch.salesBridge.anomaly.activeStale": "过期商品仍在售",
  "dispatch.salesBridge.refetchShopify": "刷新 Shopify 数据",
  "dispatch.salesBridge.refetching": "正在刷新 Shopify 数据…",
  "dispatch.salesBridge.refetchApplied": "Shopify 数据已刷新",
  "dispatch.salesBridge.refetchNoChange": "Shopify 数据无变化",
  "dispatch.salesBridge.refetchError": "刷新 Shopify 数据失败",
  "dispatch.salesBridge.reason.pending": "待付款",
  "dispatch.salesBridge.reason.authorized": "已授权",
  "dispatch.salesBridge.reason.expired": "已过期",
  "dispatch.salesBridge.reason.partiallyPaid": "部分付款",
  "dispatch.salesBridge.reason.paid": "已付款",
  "dispatch.salesBridge.reason.partiallyRefunded": "部分退款",
  "dispatch.salesBridge.reason.refunded": "已退款",
  "dispatch.salesBridge.reason.voided": "已作废",
  "dispatch.salesBridge.reason.unknown": "未知财务状态",
  "dispatch.funnel.title": "今日派单全貌",
  "dispatch.funnel.demand.label": "需求",
  "dispatch.funnel.demand.summary": "{{orders}} 单 · {{units}} 件",
  "dispatch.funnel.demand.sameProductNote_one": "其中 {{count}} 单为一单多件（同一商品 ≥2 件）",
  "dispatch.funnel.demand.sameProductNote_other": "其中 {{count}} 单为一单多件（同一商品 ≥2 件）",
  "dispatch.funnel.demand.excludedNote": "另有 {{orders}} 单 · {{units}} 件当日下单但不配送(退款/取消)",
  "dispatch.funnel.demand.source": "来源: 订单商品行 · 按行发货日",
  "dispatch.funnel.jobs.label": "建单",
  "dispatch.funnel.jobs.ok_one": "{{count}} 配送单 · 缺口 0",
  "dispatch.funnel.jobs.ok_other": "{{count}} 配送单 · 缺口 0",
  "dispatch.funnel.jobs.gap_one": "{{count}} 配送单 · 缺口 {{gap}}",
  "dispatch.funnel.jobs.gap_other": "{{count}} 配送单 · 缺口 {{gap}}",
  "dispatch.funnel.jobs.source": "来源: 订单侧独立探针 ↔ 配送单表(独立核对)",
  "dispatch.funnel.jobs.drilldownTitle": "无配送单的订单",
  "dispatch.funnel.dispatch.label": "派单",
  "dispatch.funnel.dispatch.summary": "已派 {{dispatched}} / 待派 {{undispatched}}",
  "dispatch.funnel.dispatch.beforeCutoff": "今天还没派单(未到 {{at}} 派单 cutoff)— 正常",
  "dispatch.funnel.dispatch.afterCutoff_one": "已过 {{at}} cutoff — 仍有 {{count}} 张配送单未派",
  "dispatch.funnel.dispatch.afterCutoff_other": "已过 {{at}} cutoff — 仍有 {{count}} 张配送单未派",
  "dispatch.funnel.dispatch.done": "全部配送单已派出",
  "dispatch.funnel.dispatch.source": "来源: 配送单表 · Onfleet 司机任务关联 · 手动派单动作",
  "dispatch.funnel.dispatch.drilldownTitle": "还未派到 Onfleet 的配送单",
  "dispatch.funnel.coordinates.label": "坐标",
  "dispatch.funnel.coordinates.summary": "{{ready}} 就绪 / {{pending}} 待获取",
  "dispatch.funnel.coordinates.pendingNote": "待获取订单在派单后自动获得坐标 — 非错误",
  "dispatch.funnel.coordinates.alert_one": "{{count}} 单需关注(已派仍无坐标,或悬垂引用)",
  "dispatch.funnel.coordinates.alert_other": "{{count}} 单需关注(已派仍无坐标,或悬垂引用)",
  "dispatch.funnel.coordinates.source": "来源: 排线 stops · 地理编码缓存(Shopify/Onfleet 坐标)",
  "dispatch.funnel.coordinates.drilldownTitle": "坐标状态明细",
  "dispatch.funnel.coordinates.orderMissing": "（订单缺失）",
  "dispatch.openReviewItems": "待处理审查项",
  "dispatch.critical": "{{count}} 严重",
  "dispatch.error": "{{count}} 错误",
  "dispatch.error.paid_sweep_not_run_today": "今日 paid-sweep 尚未完成。Cron 顺序为 05:00 PT 派单 → 06:00 PT sweep；今日 sweep 之前手动派单会针对尚未接收今日补漏的 fulfillment_jobs 表执行。请等待 06:00 PT 的 sweep 定时任务运行、手动触发 sweep，或在确认覆盖率后追加 ?force=true 参数。",
  "dispatch.warn": "{{count}} 警告",
  "dispatch.noOpenReviewItems": "无待处理事项",
  "dispatch.reviewItemsPending_one": "{{count}} 项待处理",
  "dispatch.reviewItemsPending_other": "{{count}} 项待处理",
  "dispatch.columnJobId": "配送单 ID",
  "dispatch.columnOrder": "订单",
  "dispatch.columnRecipient": "收件人",
  "dispatch.columnAddress": "地址",
  "dispatch.columnDeliveryDate": "配送日期",
  "dispatch.noPlannedJobs": "{{date}} 暂无待派单配送单",
  "dispatch.dispatchCompleted": "派单已完成",
  "dispatch.dispatchPartial": "派单未完成",
  "dispatch.runSummary": "{{date}} 派单完成：成功 {{dispatched}}。",
  "dispatch.runPartialSummary": "{{date}} 已派单 {{dispatched}}；仍有 {{remaining}} 待处理——请检查 Onfleet 后重试。",
  "dispatch.noResults": "无返回结果",
  "dispatch.dispatchFailed": "派单失败",
  "dispatch.cancelJob": "取消",
  "dispatch.cancelJobTitle": "取消配送单",
  "dispatch.cancelJobConfirm": "取消订单 {{order}} 的待派单配送单 ({{id}})？",
  "dispatch.jobCancelled": "配送单已取消",
  "dispatch.jobCancelledMsg": "该待派单配送单已被取消。",
  "dispatch.cancelFailed": "取消失败",
  "passwordChange.password": "密码",
  "passwordChange.passwordDesc": "更新密码以确保账户安全",
  "passwordChange.changePassword": "修改密码",
  "passwordChange.title": "修改密码",
  "passwordChange.subtitle": "输入当前密码并设置新密码",
  "passwordChange.currentPassword": "当前密码",
  "passwordChange.newPassword": "新密码",
  "passwordChange.confirmNewPassword": "确认新密码",
  "passwordChange.currentRequired": "请输入当前密码",
  "passwordChange.passwordInvalid": "密码不符合要求",
  "passwordChange.passwordMismatch": "两次输入的密码不一致",
  "passwordChange.passwordSame": "新密码不能与当前密码相同",
  "passwordChange.updatePassword": "更新密码",
  "passwordChange.updating": "更新中...",
  "role.admin": "管理员",
  "role.admin.desc": "完整的系统访问权限，包括用户管理、同步和设置。",
  "role.operator": "运营",
  "role.operator.desc": "可读取所有数据；管理订单、派单、司机、司机任务、异常处理及备注。",
  "role.viewer": "只读用户",
  "role.viewer.desc": "只读访问所有数据，无派单或管理操作权限。",
  "perm.customers": "客户",
  "perm.products": "产品",
  "perm.orders": "订单",
  "perm.dispatch": "派单",
  "perm.users": "用户",
  "perm.packaging": "配送单打印",
  "perm.review": "运营收件箱",
  "perm.webhook_failures": "Webhook 失败",
  "perm.catalog": "目录",
  "perm.inventory": "库存",
  "perm.stocktake": "盘点",
  "perm.procurement": "采购",
  "perm.audit": "变更历史",
  "perm.debug": "调用链",
  "status.completed": "已完成",
  "status.inProgress": "进行中",
  "status.assigned": "已分配",
  "status.cancelled": "已取消",
  "status.pending": "待处理",
  "status.unassigned": "未分配",
  "priority.high": "↑ 高",
  "priority.low": "↓ 低",
  "priority.medium": "→ 中",
  "op.contains": "包含",
  "op.containsCI": "包含（不区分大小写）",
  "op.equals": "等于",
  "op.notEquals": "不等于",
  "op.lessThan": "小于",
  "op.greaterThan": "大于",
  "op.lessThanLex": "小于（字典序）",
  "op.greaterThanLex": "大于（字典序）",
  "op.is": "是",
  "op.isNot": "不是",
  "op.in": "包含于",
  "op.from": "起始 (>=)",
  "op.to": "截止 (<=)",
  "op.between": "介于",
  "op.equalsDay": "等于（天）",
  "auth.loginFailed": "登录失败",
  "auth.registrationFailed": "注册失败",
  "auth.unexpectedSignIn": "登录过程中发生意外错误。",
  "auth.unexpectedSignUp": "注册过程中发生意外错误。",
  "auth.loadingAuth": "加载认证信息...",
  "auth.permissionsError.title": "无法加载权限",
  "auth.permissionsError.message": "未能加载您的访问权限。请检查网络连接后重试。",
  "auth.permissionsError.retry": "重试",
  "auth.permissionsError.signOut": "退出登录",
  "resource.createFailed": "创建失败",
  "resource.updateFailed": "更新失败",
  "resource.editTitle": "编辑{{name}}",
  "resource.selectField": "请选择{{field}}",
  "resource.validation.invalidType": "值的类型不正确。",
  "resource.validation.tooSmall": "值太短。",
  "resource.validation.tooBig": "值太长。",
  "resource.validation.invalidOption": "请选择有效选项。",
  "resource.validation.invalidFormat": "值的格式无效。",
  "resource.validation.unrecognizedField": "无法识别的字段。",
  "ui.na": "N/A",
  "driver.selector.title": "选择司机",
  "driver.selector.allDrivers": "所有司机",
  "driver.selector.allDriversExport": "所有司机（导出全部数据）",
  "driver.selector.loadFailed": "加载司机失败：{{error}}",
  "driver.selector.choose": "选择司机",
  "driver.selector.noDrivers": "该日期没有可用司机",
  "json.tableAria": "JSON 数据表",
  "json.copy": "复制 JSON",
  "json.copied": "已复制",
  "json.expand": "放大查看",
  "json.diff.tableAria": "JSON 对比表",
  "json.diff.colKey": "键",
  "json.diff.colBefore": "变更前",
  "json.diff.colAfter": "变更后",
  "json.diff.onlyChanged": "仅显示变更",
  "json.diff.removed": "已移除",
  "json.diff.cleared": "已清空",
  "json.diff.added": "新增",
  "json.diff.changed_one": "{{count}} 处变更",
  "json.diff.changed_other": "{{count}} 处变更",
  "json.diff.moreRows_one": "还有 {{count}} 行",
  "json.diff.moreRows_other": "还有 {{count}} 行",
  "users.inviteUserFailed": "邀请用户失败",
  "users.error.email_taken": "该邮箱已被一个账号占用。",
  "users.updateUserFailed": "更新用户失败",
  "users.disableUserFailed": "禁用用户失败",
  "ui.saving": "保存中…",
  "nav.docs": "文档",
  "docs.title": "文档",
  "packaging.title": "配送单打印",
  "packaging.cutoff.title": "发现 10:00 截单后订单变更",
  "packaging.cutoff.body_one": "{{date}} 有 {{count}} 条未处理的截单后异常，请点击查看。",
  "packaging.cutoff.body_other": "{{date}} 有 {{count}} 条未处理的截单后异常，请点击查看。",
  "packaging.dateLabel": "日期",
  "packaging.download.csv": "导出 CSV",
  "packaging.print": "打印",
  "packaging.empty": "没有匹配的配送单。",
  "packaging.generatedAt": "生成时间：{{time}}",
  "packaging.group.unassigned": "未分配",
  "packaging.gift.badge": "含赠品",
  "packaging.item.unallocated": "未安置",
  "packaging.card.orderNote": "订单备注",
  "packaging.card.jobNote": "配送单备注",
  "packaging.card.perDriverPageBreak": "按司机分页",
  "packaging.error.loadFailed": "加载配送单打印失败。",
  "packaging.export.success.title": "导出成功",
  "packaging.export.failed.title": "导出失败",
  "packaging.export.failed.body": "CSV 导出未能生成。请重试；如果问题仍然存在，请查看开发者控制台。",
  "packaging.print.failed.title": "无法打开打印预览",
  "packaging.print.failed.body": "打印预览渲染失败。请重试；如果问题仍然存在，请查看开发者控制台。",
  "packaging.print.popupBlocked.title": "弹窗被拦截",
  "packaging.print.popupBlocked.body": "请为当前站点允许弹出窗口，以便打印预览在新标签页中打开。",
  "order.structure.title": "配送单",
  "order.structure.noJobs": "尚未生成配送单。",
  "order.structure.loading": "正在加载配送单…",
  "order.structure.errorLoad": "加载配送单失败。详情：{{detail}}",
  "order.structure.deliveryDate": "配送 {{date}}",
  "order.structure.flexibleDate": "灵活",
  "order.structure.presumedCoverage": "同地址同日兄弟 {{order}} 已有司机任务 {{task}}，推定本单已被该趟覆盖。",
  "order.structure.toggleItems": "商品明细",
  "order.structure.itemQuantity": "× {{quantity}}",
  "order.structure.itemUntitled": "（未命名商品）",
  "order.structure.itemsEmpty": "本配送单没有商品明细。",
  "order.structure.itemsUnavailable": "本配送单的商品明细无法读取（数据异常），不代表它没有商品。",
  "order.structure.unassignedItems": "未归入任何配送单的项目",
  "order.structure.gapUnavailable": "有配送单的商品明细无法读取，未归入项目暂时无法核算。",
  "ingredient.label": "食材",
  "ingredient.field.id": "ID",
  "ingredient.field.name": "名称",
  "ingredient.field.unit": "单位",
  "ingredient.field.category": "分类",
  "ingredient.field.storage": "储存",
  "ingredient.field.shelfLifeDays": "保质期（天）",
  "ingredient.field.defaultSupplierId": "默认供应商",
  "ingredient.field.safetyStock": "安全库存",
  "ingredient.field.photoUrl": "图片地址",
  "ingredient.field.notes": "备注",
  "ingredient.field.createdAt": "创建时间",
  "ingredient.field.updatedAt": "更新时间",
  "ingredient.enum.storage.ambient": "常温",
  "ingredient.enum.storage.chilled": "冷藏",
  "ingredient.enum.storage.frozen": "冷冻",
  "ingredient.enum.unit.g": "克",
  "ingredient.enum.unit.kg": "千克",
  "ingredient.enum.unit.ml": "毫升",
  "ingredient.enum.unit.l": "升",
  "ingredient.enum.unit.piece": "个",
  "ingredient.enum.unit.bunch": "把",
  "ingredient.enum.category.protein": "肉蛋",
  "ingredient.enum.category.vegetable": "蔬菜",
  "ingredient.enum.category.seasoning": "调味",
  "ingredient.enum.category.sauce": "酱料",
  "ingredient.enum.category.staple": "主食",
  "ingredient.enum.category.other": "其他",
  "ingredient.group.identity": "基本信息",
  "ingredient.group.meta": "元数据",
  "ingredient.searchPlaceholder": "按名称或备注搜索食材…",
  "ingredient.form.createTitle": "新建食材",
  "ingredient.form.editTitle": "编辑食材",
  "supplier.label": "供应商",
  "supplier.field.id": "ID",
  "supplier.field.name": "名称",
  "supplier.field.contact": "联系人",
  "supplier.field.phone": "电话",
  "supplier.field.email": "邮箱",
  "supplier.field.leadTimeDays": "交货周期（天）",
  "supplier.field.minOrderValue": "起订金额",
  "supplier.field.currency": "币种",
  "supplier.field.paymentTerms": "付款条款",
  "supplier.field.status": "状态",
  "supplier.field.createdAt": "创建时间",
  "supplier.field.updatedAt": "更新时间",
  "supplier.enum.status.active": "正常",
  "supplier.enum.status.paused": "暂停",
  "supplier.group.identity": "基本信息",
  "supplier.group.meta": "元数据",
  "supplier.searchPlaceholder": "按名称、联系人或邮箱搜索供应商…",
  "supplier.form.createTitle": "新建供应商",
  "supplier.form.editTitle": "编辑供应商",
  "nav.catalog": "目录",
  "nav.catalog.ingredients": "食材",
  "nav.catalog.suppliers": "供应商",
  "nav.catalog.dishes": "菜品",
  "nav.catalog.combos": "套餐",
  "nav.menuPlanning": "菜单计划",
  "nav.menuPlanning.plans": "周计划",
  "nav.inventory": "库存",
  "nav.inventory.stock": "库存量",
  "nav.procurement.section": "采购",
  "nav.procurement.suggestions": "采购建议",
  "nav.procurement.purchaseOrders": "采购单",
  "procurement.common.refresh": "刷新",
  "procurement.suggestions.title": "采购建议",
  "procurement.suggestions.subtitle": "预测器生成的可操作队列。填入单价后接受某行即生成一张采购单草稿，或将其忽略。",
  "procurement.suggestions.empty": "暂无待处理建议。",
  "procurement.suggestions.loadError": "加载采购建议失败，请重试。",
  "procurement.suggestions.accept": "接受",
  "procurement.suggestions.dismiss": "忽略",
  "procurement.suggestions.acceptSuccess": "已接受建议，并生成一张采购单草稿。",
  "procurement.suggestions.dismissSuccess": "已忽略该建议。",
  "procurement.suggestions.priceRequired": "接受前请先填写单价。",
  "procurement.suggestions.invalidPrice": "单价必须为正数。",
  "procurement.suggestions.unitPricePh": "单价",
  "procurement.suggestions.supplier": "供应商：{{supplier}}",
  "procurement.suggestions.lineCount_one": "共 {{count}} 行",
  "procurement.suggestions.lineCount_other": "共 {{count}} 行",
  "procurement.suggestions.viewPOs": "查看采购单 →",
  "procurement.suggestions.col.ingredient": "食材",
  "procurement.suggestions.col.suggestedQty": "建议数量",
  "procurement.suggestions.col.unit": "单位",
  "procurement.suggestions.col.unitPrice": "单价",
  "procurement.suggestions.col.actions": "操作",
  "procurement.purchaseOrders.title": "采购单",
  "procurement.purchaseOrders.subtitle": "按状态 / 供应商筛选。点击行查看明细并开始收货。",
  "procurement.purchaseOrders.empty": "当前筛选条件下无采购单。",
  "procurement.purchaseOrders.loadError": "加载采购单失败，请重试。",
  "procurement.purchaseOrders.receive": "收货",
  "procurement.purchaseOrders.submit": "提交",
  "procurement.purchaseOrders.cancel": "取消",
  "procurement.purchaseOrders.close": "关闭",
  "procurement.purchaseOrders.submitSuccess": "采购单已提交。",
  "procurement.purchaseOrders.cancelSuccess": "采购单已取消。",
  "procurement.purchaseOrders.closeSuccess": "采购单已关闭。",
  "procurement.purchaseOrders.detailTitle": "采购单 {{id}}",
  "procurement.purchaseOrders.linesTitle": "行项目",
  "procurement.purchaseOrders.noLines": "该采购单无行项目。",
  "procurement.purchaseOrders.col.id": "采购单号",
  "procurement.purchaseOrders.col.supplier": "供应商",
  "procurement.purchaseOrders.col.status": "状态",
  "procurement.purchaseOrders.col.orderedAt": "下单时间",
  "procurement.purchaseOrders.col.total": "金额",
  "procurement.purchaseOrders.col.expectedDeliveryAt": "预计到货",
  "procurement.purchaseOrders.col.receivedAt": "收货时间",
  "procurement.purchaseOrders.col.currency": "币种",
  "procurement.purchaseOrders.col.notes": "备注",
  "procurement.purchaseOrders.col.createdAt": "创建时间",
  "procurement.purchaseOrders.col.updatedAt": "更新时间",
  "procurement.purchaseOrders.col.ingredient": "食材",
  "procurement.purchaseOrders.col.qtyOrdered": "订购",
  "procurement.purchaseOrders.col.qtyReceived": "已收",
  "procurement.purchaseOrders.col.unit": "单位",
  "procurement.receive.title": "收货",
  "procurement.receive.subtitle": "为采购单 {{id}} 录入收货。",
  "procurement.receive.lines": "待收行",
  "procurement.receive.allReceived": "该采购单的所有行均已完成收货。",
  "procurement.receive.linePrompt": "剩余：{{remaining}} {{unit}}",
  "procurement.receive.keypadFor": "录入：{{ingredient}}",
  "procurement.receive.keypadIdle": "数字键盘",
  "procurement.receive.keypadKey": "按键 {{key}}",
  "procurement.receive.backspace": "退格",
  "procurement.receive.clear": "清零",
  "procurement.receive.fill": "填满剩余",
  "procurement.receive.next": "下一行",
  "procurement.receive.cancel": "取消",
  "procurement.receive.submit_one": "提交收货 ({{count}} 行)",
  "procurement.receive.submit_other": "提交收货 ({{count}} 行)",
  "procurement.receive.submitSuccess": "收货已记录。采购单状态：{{status}}。",
  "procurement.receive.invalidQty": "请先输入大于 0 的数量再点击下一行。",
  "procurement.receive.overflow": "数量超过该行剩余可收数量。",
  "procurement.receive.missingId": "URL 缺少采购单 id。",
  "procurement.receive.loadError": "加载采购单失败。",
  "procurement.status.draft": "草稿",
  "procurement.status.submitted": "已下单",
  "procurement.status.partially_received": "部分收货",
  "procurement.status.received": "已收货",
  "procurement.status.cancelled": "已取消",
  "procurement.status.closed": "已关闭",
  "nav.stocktake.section": "盘点",
  "nav.stocktake.list": "盘点",
  "stocktake.common.refresh": "刷新",
  "stocktake.status.open": "进行中",
  "stocktake.status.counted": "已录入",
  "stocktake.status.committed": "已提交",
  "stocktake.status.cancelled": "已取消",
  "stocktake.list.title": "盘点",
  "stocktake.list.subtitle": "每周清点 + 差异复核。点击行继续录入或复核差异。",
  "stocktake.list.loadError": "加载盘点列表失败，请重试。",
  "stocktake.list.openWeekLabel": "起始周一",
  "stocktake.list.openButton": "开启盘点",
  "stocktake.list.openSuccess": "已为周 {{week}} 开启盘点。",
  "stocktake.list.col.week": "周",
  "stocktake.list.col.status": "状态",
  "stocktake.list.col.openedAt": "开启时间",
  "stocktake.list.col.closedAt": "关闭时间",
  "stocktake.list.col.openedBy": "开启人",
  "stocktake.count.title": "录入 — {{week}} 当周",
  "stocktake.count.subtitle_one": "状态：{{status}} · {{count}} 行中尚有 {{remaining}} 行未录。",
  "stocktake.count.subtitle_other": "状态：{{status}} · {{count}} 行中尚有 {{remaining}} 行未录。",
  "stocktake.count.back": "返回盘点列表",
  "stocktake.count.cancelStocktake": "取消盘点",
  "stocktake.count.cancelConfirm": "确认取消此盘点？已录入的数量将被丢弃且不会调整库存账。",
  "stocktake.count.cancelSuccess": "盘点已取消。",
  "stocktake.count.reviewLink": "复核差异",
  "stocktake.count.lines": "食材",
  "stocktake.count.emptyLines": "此盘点暂无食材。",
  "stocktake.count.focusLine": "选中 {{ingredient}}",
  "stocktake.count.systemQty": "系统：{{qty}}",
  "stocktake.count.counted": "已录",
  "stocktake.count.uncounted": "未录",
  "stocktake.count.keypadFor": "录入：{{ingredient}}",
  "stocktake.count.keypadIdle": "数字键盘",
  "stocktake.count.keypadKey": "按键 {{key}}",
  "stocktake.count.backspace": "退格",
  "stocktake.count.clear": "清空",
  "stocktake.count.matchSystem": "与系统一致",
  "stocktake.count.next": "下一行",
  "stocktake.count.save": "保存数量 ({{count}})",
  "stocktake.count.saveSuccess_one": "已保存 {{count}} 项。",
  "stocktake.count.saveSuccess_other": "已保存 {{count}} 项。",
  "stocktake.count.invalidQty": "{{ingredient}} 的盘点数量必须为非负数。",
  "stocktake.count.nothingToSave": "请先输入数量再保存。",
  "stocktake.count.partialSaveFailure_one": "已保存 {{saved}}/{{count}} 行，其余失败。请重试以保存剩余行。",
  "stocktake.count.partialSaveFailure_other": "已保存 {{saved}}/{{count}} 行，其余失败。请重试以保存剩余行。",
  "stocktake.count.missingId": "URL 缺少盘点 id。",
  "stocktake.count.loadError": "加载盘点失败。",
  "stocktake.review.title": "复核 — {{week}} 当周",
  "stocktake.review.subtitle": "{{positive}} 项盈余 · {{negative}} 项短缺 · {{zero}} 项一致 · {{uncounted}} 项未录。",
  "stocktake.review.back": "返回盘点列表",
  "stocktake.review.backToCount": "返回录入",
  "stocktake.review.positiveGroup": "盈余 ({{count}})",
  "stocktake.review.negativeGroup": "短缺 ({{count}})",
  "stocktake.review.zeroGroup": "无差异 ({{count}})",
  "stocktake.review.uncountedGroup": "未录 ({{count}})",
  "stocktake.review.col.ingredient": "食材",
  "stocktake.review.col.systemQty": "系统",
  "stocktake.review.col.countedQty": "实盘",
  "stocktake.review.col.varianceQty": "差异",
  "stocktake.review.commitTitle": "提交盘点",
  "stocktake.review.commitWarning": "{{nonZero}} 行将调整库存账。{{uncounted}} 行未录将不会产生调整。此操作不可逆。",
  "stocktake.review.confirmCheckbox": "我已复核所有差异，确认关闭并调整库存账。",
  "stocktake.review.confirmRequired": "提交前请勾选确认。",
  "stocktake.review.commitButton": "关闭并调整库存账",
  "stocktake.review.commitSuccess": "盘点已提交，库存账已更新。",
  "stocktake.review.cancelStocktake": "取消盘点",
  "stocktake.review.cancelConfirm": "确认取消此盘点？已录入的数量将被丢弃且不会调整库存账。",
  "stocktake.review.cancelSuccess": "盘点已取消。",
  "stocktake.review.missingId": "URL 缺少盘点 id。",
  "stocktake.review.loadError": "加载盘点失败。",
  "inventory.stock.title": "库存量",
  "inventory.stock.tableTitle": "按食材统计在手库存",
  "inventory.stock.refresh": "刷新",
  "inventory.stock.empty": "暂无食材数据。",
  "inventory.stock.loadError": "库存数据加载失败。请尝试刷新；如持续失败请联系运维。",
  "inventory.stock.onHandUnavailableTitle": "库存量暂不可用",
  "inventory.stock.onHandUnavailableDetail": "重建后端尚未提供批量库存查询端点，因此此处不显示各食材的库存量。待该接口建成后将恢复（见 #935/#936）。",
  "inventory.stock.truncatedTitle": "食材目录已截断",
  "inventory.stock.truncatedDetail": "仅显示前 {{shown}} 条，共 {{total}} 条。更大目录的支持将作为后续任务跟进。",
  "inventory.stock.col.name": "食材",
  "inventory.stock.col.unit": "单位",
  "inventory.stock.col.category": "分类",
  "inventory.stock.col.onHand": "在手数量",
  "menu_plan.label": "菜单计划",
  "menu_plan.searchPlaceholder": "按周起始日期搜索…",
  "menu_plan.field.id": "ID",
  "menu_plan.field.weekStart": "周起始",
  "menu_plan.field.status": "状态",
  "menu_plan.field.approvedBy": "审批人",
  "menu_plan.field.approvedAt": "审批时间",
  "menu_plan.field.publishedAt": "发布时间",
  "menu_plan.field.createdAt": "创建时间",
  "menu_plan.field.updatedAt": "更新时间",
  "menu_plan.group.identity": "基本信息",
  "menu_plan.group.lifecycle": "生命周期",
  "menu_plan.group.meta": "元数据",
  "menu_plan.enum.status.draft": "草稿",
  "menu_plan.enum.status.approved": "已审批",
  "menu_plan.enum.status.published": "已发布",
  "menu_plan.enum.itemStatus.planned": "已计划",
  "menu_plan.enum.itemStatus.amended": "已修改",
  "menu_plan.enum.itemStatus.requires_review": "需要复核",
  "menu_plan.items.tabLabel": "菜单项",
  "menu_plan.items.title": "菜单项 ({{count}})",
  "menu_plan.items.empty": "此计划尚无菜单项。",
  "menu_plan.items.noDishes": "—",
  "menu_plan.items.col.deliveryDate": "配送日期",
  "menu_plan.items.col.combo": "套餐",
  "menu_plan.items.col.dishes": "菜品",
  "menu_plan.items.col.status": "状态",
  "menu_plan.reviewReason.catalog.dish_archived": "菜品已归档 — 套餐引用了一个已不可用的菜品",
  "menu_plan.reviewReason.catalog.ingredient_archived": "食材已归档 — 此套餐中的菜品引用了一个已不可用的食材",
  "menu_plan.action.approve.button": "审批",
  "menu_plan.action.approve.confirmTitle": "审批菜单计划?",
  "menu_plan.action.approve.confirmMessage": "审批起始为 {{weekStart}} 的周计划?此步通过后由运营经理放行。",
  "menu_plan.action.approve.confirmAction": "审批",
  "menu_plan.action.approve.success": "计划已审批",
  "menu_plan.action.approve.failure": "审批失败",
  "menu_plan.action.publish.button": "发布",
  "menu_plan.action.publish.confirmTitle": "发布菜单计划?",
  "menu_plan.action.publish.confirmMessage": "发布起始为 {{weekStart}} 的周计划?这会为每个菜单项在 Shopify 创建商品。可通过撤销发布回退。",
  "menu_plan.action.publish.confirmAction": "发布",
  "menu_plan.action.publish.success": "计划已发布",
  "menu_plan.action.publish.successButFanoutFailed": "计划已发布,但下游 Shopify 同步失败。请使用下方的重试。",
  "menu_plan.action.publish.emitFailedBanner": "计划已发布,但下游 Shopify 商品创建失败。",
  "menu_plan.action.publish.failure": "发布失败",
  "menu_plan.action.unpublish.button": "撤销发布",
  "menu_plan.action.unpublish.confirmTitle": "撤销发布菜单计划?",
  "menu_plan.action.unpublish.confirmMessage": "撤销发布起始为 {{weekStart}} 的周计划?Shopify 商品会被隐藏,但 ID 与 URL 保留(不会出现客户端 404)。",
  "menu_plan.action.unpublish.confirmAction": "撤销发布",
  "menu_plan.action.unpublish.success": "计划已撤销发布",
  "menu_plan.action.unpublish.successButFanoutFailed": "计划已撤销发布,但下游 Shopify 同步失败。请使用下方的重试。",
  "menu_plan.action.unpublish.emitFailedBanner": "计划已撤销发布,但 Shopify 商品的隐藏操作失败。",
  "menu_plan.action.unpublish.failure": "撤销发布失败",
  "menu_plan.action.republishFanout.button": "重试同步",
  "menu_plan.action.republishFanout.success": "重试同步成功",
  "menu_plan.action.republishFanout.partial": "已重试 — 仍有条目同步失败，问题解决后请再试一次。",
  "menu_plan.action.republishFanout.failure": "重试失败 — 详见错误提示",
  "menu_plan.action.emitFailed.explanation": "计划状态已变更;点击下方按钮重新发送生命周期事件,无需重新执行状态迁移。",
  "menu_plan.action.error.invalidTransition": "非法状态迁移: {{from}} → {{to}}",
  "menu_plan.action.error.emitFailed": "下游同步失败: {{message}}",
  "menu_plan.create.openButton": "新建计划",
  "menu_plan.create.title": "创建菜单计划",
  "menu_plan.create.description": "为指定的周创建草稿计划。周必须以周一开始。",
  "menu_plan.create.weekStartPlaceholder": "选择一个周一",
  "menu_plan.create.weekStartHint": "ISO 周一,例如 2026-05-11。每周仅允许一个活动计划。",
  "menu_plan.create.submit": "创建草稿",
  "menu_plan.create.submitting": "创建中…",
  "menu_plan.create.success": "草稿计划已创建",
  "menu_plan.create.error.required": "请选择周起始日期。",
  "menu_plan.create.error.notMonday": "周必须以周一开始。",
  "menu_plan.create.error.weekCollision": "起始为 {{weekStart}} 的周已存在计划。请打开已有计划,不要创建重复项。",
  "menu_plan.create.error.unknown": "创建计划失败 — 请重试。",
  "menu_plan.items.col.actions": "操作",
  "menu_plan.amend.openButton": "修改",
  "menu_plan.amend.title": "修改菜单项",
  "menu_plan.amend.description": "替换此已发布菜单项中的一道菜(配送日 {{deliveryDate}})。INV-M2-9 限制只允许修改今天或明天(按商家时区)的菜单。",
  "menu_plan.amend.outOfWindowBanner": "配送日 {{deliveryDate}} 不在修改窗口内(仅限今天/明天)。",
  "menu_plan.amend.fromLabel": "要替换的菜品",
  "menu_plan.amend.fromPlaceholder": "选择此菜单项中的一道菜",
  "menu_plan.amend.fromHint": "仅可选当前已在此菜单项中的菜品。",
  "menu_plan.amend.toLabel": "替换为菜品 ID",
  "menu_plan.amend.toPlaceholder": "例如 d-kungpao",
  "menu_plan.amend.toHint": "输入目录中目标菜品的 ID。",
  "menu_plan.amend.submit": "确认修改",
  "menu_plan.amend.submitting": "修改中…",
  "menu_plan.amend.success": "菜单项已修改",
  "menu_plan.amend.successButFanoutFailed": "菜单项已修改,但下游 Shopify 同步失败 — 打开计划重试。",
  "menu_plan.amend.error.fromRequired": "请选择要替换的菜品。",
  "menu_plan.amend.error.toRequired": "请输入替换菜品 ID。",
  "menu_plan.amend.error.sameDish": "替换菜品必须与原菜品不同。",
  "menu_plan.amend.error.outOfWindowLocal": "配送日不在今天/明天范围内,无法修改。",
  "menu_plan.amend.error.outOfWindow": "配送日 {{deliveryDate}} 不在修改窗口内(允许: {{today}}、{{tomorrow}})。",
  "menu_plan.amend.error.dishNotFound": "未找到菜品 {{dishId}}(可能已归档)。",
  "menu_plan.amend.error.dishNotInSnapshot": "菜品 {{dishId}} 不在此菜单项的当前快照中。",
  "menu_plan.amend.error.planNotPublished": "计划未发布(当前状态: {{currentStatus}})。",
  "menu_plan.amend.error.unknown": "修改失败 — 请重试。",
  "menu_plan.amend.reasonLabel": "原因",
  "menu_plan.amend.reasonPlaceholder": "请选择原因…",
  "menu_plan.amend.reason.combo_changed": "套餐变更",
  "menu_plan.amend.reason.dish_substituted": "菜品替换",
  "menu_plan.amend.reason.cancelled": "已取消",
  "menu_plan.amend.dishesLabel": "菜品快照(JSON)",
  "menu_plan.amend.dishesHint": "以 JSON 数组编辑该条目的菜品列表。保存后会重新渲染关联的 Shopify 商品标题。",
  "menu_plan.amend.successNotLinked": "条目已修改(无关联的 Shopify 商品可更新)。",
  "menu_plan.amend.error.reasonRequired": "请为本次修改选择原因。",
  "menu_plan.amend.error.dishesRequired": "菜品快照不能为空。",
  "menu_plan.amend.error.invalidJson": "菜品快照必须是有效的 JSON 数组。",
  "menu_plan.weekPage.title": "起始日期 {{weekStart}} 的周计划",
  "menu_plan.weekPage.subtitle": "状态: {{status}}",
  "menu_plan.weekPage.emptyDay": "暂无菜单项。",
  "menu_plan.weekPage.addButton": "添加",
  "menu_plan.weekPage.deleteSuccess": "菜单项已移除",
  "menu_plan.weekPage.deleteFailure": "移除菜单项失败",
  "menu_plan.weekPage.deletePlanNotDraft": "无法删除:计划已不在草稿状态(当前: {{currentStatus}})。请先撤销发布。",
  "menu_plan.weekPage.deleteConfirmTitle": "移除菜单项?",
  "menu_plan.weekPage.deleteConfirmMessage": "从 {{deliveryDate}} 移除套餐 {{comboId}}?仅在计划为草稿状态时可执行。",
  "menu_plan.weekPage.weekday.monday": "周一",
  "menu_plan.weekPage.weekday.tuesday": "周二",
  "menu_plan.weekPage.weekday.wednesday": "周三",
  "menu_plan.weekPage.weekday.thursday": "周四",
  "menu_plan.weekPage.weekday.friday": "周五",
  "menu_plan.weekPage.weekday.saturday": "周六",
  "menu_plan.weekPage.weekday.sunday": "周日",
  "menu_plan.weekPage.openButton": "周视图",
  "menu_plan.upsertItem.titleCreate": "添加菜单项",
  "menu_plan.upsertItem.titleEdit": "编辑菜单项",
  "menu_plan.upsertItem.description": "将一个套餐排入配送日 {{deliveryDate}}。每个 (日期, 计划) 只允许一个套餐 — 后端会用 409 拒绝重复。",
  "menu_plan.upsertItem.comboLabel": "套餐",
  "menu_plan.upsertItem.comboPlaceholder": "选择一个套餐",
  "menu_plan.upsertItem.comboLoading": "套餐加载中…",
  "menu_plan.upsertItem.comboHint": "只列出活动套餐;已归档的不会出现。",
  "menu_plan.upsertItem.submitCreate": "添加",
  "menu_plan.upsertItem.submitEdit": "保存",
  "menu_plan.upsertItem.submitting": "保存中…",
  "menu_plan.upsertItem.successCreate": "菜单项已添加",
  "menu_plan.upsertItem.successEdit": "菜单项已更新",
  "menu_plan.upsertItem.error.comboRequired": "请选择要添加的套餐。",
  "menu_plan.upsertItem.error.planNotDraft": "计划不在草稿状态(当前: {{currentStatus}});只有草稿计划允许修改菜单项。",
  "menu_plan.upsertItem.error.slotCollision": "{{deliveryDate}} 已存在套餐 {{comboId}} 的菜单项。请编辑已有项,不要重复添加。",
  "menu_plan.upsertItem.error.unknown": "保存菜单项失败 — 请重试。",
  "menu_plan.reviewPage.title": "评估 — {{weekStart}} 当周",
  "menu_plan.reviewPage.subtitle": "规划阶段的食材需求投影。调整预估每日订单量以预览任一阶段（草稿 / 已审批 / 已发布）的物料需求。",
  "menu_plan.reviewPage.estimateCardTitle": "投影参数",
  "menu_plan.reviewPage.estimateLabel": "预估每日订单数",
  "menu_plan.reviewPage.resetButton": "重置为 {{value}}",
  "menu_plan.reviewPage.estimateInvalid": "请输入 0 到 {{max}} 之间的非负整数。",
  "menu_plan.reviewPage.costColumnNotice": "成本投影（单价 × 数量）将在 M3 采购阶段提供 — 此页只展示数量。",
  "menu_plan.reviewPage.tableCardTitle": "食材需求 ({{count}} 项)",
  "menu_plan.reviewPage.columnIngredient": "食材",
  "menu_plan.reviewPage.columnQty": "总需求量",
  "menu_plan.reviewPage.columnUnit": "单位",
  "menu_plan.reviewPage.unitBreakdown": "按单位分布：{{breakdown}}。",
  "menu_plan.reviewPage.emptyPlan": "本周计划还没有菜单项。先到周视图新增套餐。",
  "menu_plan.reviewPage.emptyPlanCta": "打开周视图",
  "menu_plan.reviewPage.emptyNeeds": "未计算出食材需求 — 此计划下的套餐菜品尚未配置配方。",
  "menu_plan.reviewPage.openButton": "查看需求",
  "menu_plan.reviewPage.linkLabel": "查看本周菜单的食材需求投影。",
  "menu_plan.reviewPage.error404": "此菜单计划已删除。返回列表选择其他计划。",
  "menu_plan.reviewPage.errorGeneric": "无法加载食材需求。请尝试调整每日订单数，或稍后重试。",
  "dish.label": "菜品",
  "dish.field.id": "ID",
  "dish.field.name": "名称",
  "dish.field.nameZh": "中文名",
  "dish.field.nameEn": "英文名",
  "dish.field.category": "分类",
  "dish.field.portionGrams": "份量 (克)",
  "dish.field.cookTimeMin": "烹饪时间 (分钟)",
  "dish.field.description": "描述",
  "dish.field.status": "状态",
  "dish.field.createdAt": "创建时间",
  "dish.field.updatedAt": "更新时间",
  "dish.enum.status.active": "正常",
  "dish.enum.status.archived": "已归档",
  "dish.enum.category.stir_fry": "炒菜",
  "dish.enum.category.soup": "汤品",
  "dish.enum.category.cold": "凉菜",
  "dish.enum.category.staple": "主食",
  "dish.enum.category.other": "其它",
  "dish.group.identity": "基本信息",
  "dish.group.meta": "元数据",
  "dish.searchPlaceholder": "按名称搜索菜品…",
  "dish.form.createTitle": "新建菜品",
  "dish.form.editTitle": "编辑菜品",
  "dish.recipe.title": "配方行",
  "dish.recipe.empty": "暂无配方行——先添加一个食材开始。",
  "dish.recipe.ingredient": "食材",
  "dish.recipe.qty": "份量/份",
  "dish.recipe.unit": "单位",
  "dish.recipe.prepNote": "处理备注",
  "dish.recipe.prepNotePlaceholder": "切丁 / 切片 …",
  "dish.recipe.addRow": "添加食材",
  "dish.recipe.save": "保存配方",
  "dish.recipe.saved": "配方已保存。",
  "dish.recipe.saveFailed": "保存配方失败",
  "dish.recipe.loadFailed": "加载配方失败——请重试。",
  "dish.recipe.catalogTruncatedTitle": "食材列表已截断",
  "dish.recipe.catalogTruncatedDetail": "已显示 {{total}} 项食材中的前 {{shown}} 项。部分条目在 M2 上线类型搜索之前可能无法选择。",
  "dish.recipe.error.line.ingredientMissing": "{{ingredient}} —— 食材不存在。",
  "dish.recipe.error.line.unitMismatch": "{{ingredient}} —— 单位应为 {{expected}}，实际为 {{got}}。",
  "dish.recipe.error.line.duplicate": "{{ingredient}} —— 出现多次。",
  "dish.recipe.savedWithSkippedTitle": "部分行已跳过",
  "dish.recipe.savedWithSkippedDetail_one": "{{count}} 行缺少食材、份量或单位，未保存。",
  "dish.recipe.savedWithSkippedDetail_other": "{{count}} 行缺少食材、份量或单位，未保存。",
  "combo.label": "套餐",
  "combo.field.id": "ID",
  "combo.field.code": "代号",
  "combo.field.name": "名称",
  "combo.field.description": "描述",
  "combo.field.price": "价格",
  "combo.field.status": "状态",
  "combo.field.createdAt": "创建时间",
  "combo.field.updatedAt": "更新时间",
  "combo.enum.status.active": "正常",
  "combo.enum.status.archived": "已归档",
  "combo.group.identity": "基本信息",
  "combo.group.meta": "元数据",
  "combo.searchPlaceholder": "按名称或代号搜索套餐…",
  "combo.form.createTitle": "新建套餐",
  "combo.form.editTitle": "编辑套餐",
  "combo.slots.title": "槽位分配",
  "combo.slots.empty": "暂无槽位——添加一行开始组合该套餐。",
  "combo.slots.slot": "槽位",
  "combo.slots.enum.main": "首道主菜",
  "combo.slots.enum.main2": "二道主菜",
  "combo.slots.enum.main3": "三道主菜",
  "combo.slots.enum.side": "配菜",
  "combo.slots.enum.soup": "汤",
  "combo.slots.enum.staple": "主食",
  "combo.slots.dish": "菜品",
  "combo.slots.displayOrder": "显示顺序",
  "combo.slots.addRow": "添加槽位",
  "combo.slots.save": "保存槽位",
  "combo.slots.saved": "槽位已保存。",
  "combo.slots.saveFailed": "保存槽位失败",
  "combo.slots.loadFailed": "加载槽位失败——请重试。",
  "combo.slots.catalogTruncatedTitle": "菜品列表已截断",
  "combo.slots.catalogTruncatedDetail": "已显示 {{total}} 项启用菜品中的前 {{shown}} 项。部分条目在 M2 上线类型搜索之前可能无法选择。",
  "combo.slots.error.line.dishMissing": "{{dish}} —— 菜品不存在。",
  "combo.slots.error.line.dishInactive": "{{dish}} —— 菜品已归档；只能选择启用状态的菜品。",
  "combo.slots.error.line.duplicate": "{{slot}} / {{dish}} —— (槽位, 菜品) 重复。",
  "combo.slots.savedWithSkippedTitle": "部分行已跳过",
  "combo.slots.savedWithSkippedDetail_one": "{{count}} 行缺少槽位或菜品，未保存。",
  "combo.slots.savedWithSkippedDetail_other": "{{count}} 行缺少槽位或菜品，未保存。",
  "ui.remove": "移除",
  "dispatch.dispatchable": "可派单",
  "dispatch.stopAlreadyDispatchedTitle": "同址已派出（{{count}}）",
  "dispatch.stopAlreadyDispatchedReason": "与 {{orderName}} 同址，其司机任务已派出；本配送单将单独派成一个司机任务（上次派单中断遗留的原配送单除外，它会并回原司机任务）。若 {{orderName}} 的配送单是单独派出的（未合并），这些同址配送单可能改为合并派成一个新的司机任务",
  "dispatch.columnReason": "原因",
  "dispatch.anomalyReason.order_not_found": "找不到这张订单，配送单还在待派单",
  "dispatch.anomalyReason.order_cancelled": "订单在 Shopify 已取消，配送单还在待派单",
  "dispatch.undated.title": "无配送日订单",
  "dispatch.undated.count_one": "{{count}} 单",
  "dispatch.undated.count_other": "{{count}} 单",
  "dispatch.undated.subtitle": "没有配送日、也没有配送单。每一天都显示同一批，排到这一天才进入这一天",
  "dispatch.undated.schedule": "排到这一天",
  "dispatch.undated.scheduleAll": "全部排到这一天",
  "dispatch.undated.retry": "重试",
  "dispatch.undated.failed": "没有排进去：",
  "dispatch.undated.pastCutoff": "已过 {{at}} 派单截止 — 仍可排到今天，派单前请确认",
  "dispatch.preCheck.title": "派单前要先看的",
  "dispatch.preCheck.subtitle": "预检异常会让那一批派单失败，必须先处理；其余是提醒",
  "dispatch.preCheck.anomalies": "预检异常 · 必须先处理 · {{count}}",
  "dispatch.preCheck.anomaliesSource": "来源：派单预览 · 订单已取消 / 订单不存在",
  "dispatch.preCheck.cancelJob": "取消配送单",
  "dispatch.preCheck.shopify": "与 Shopify 不一致 · {{count}}",
  "dispatch.preCheck.shopifySource": "来源：今日需求（Shopify 侧对账）",
  "dispatch.preCheck.unpaidWhy": "未收款 · financial_status = {{status}}",
  "dispatch.preCheck.missingJobWhy": "Shopify 有这张订单的当天商品，但没有配送单",
  "dispatch.preCheck.openOrder": "打开订单",
  "dispatch.preCheck.multiQty": "一单多件 · {{count}}",
  "dispatch.preCheck.multiQtySource": "来源：今日需求",
  "dispatch.preCheck.soldOut": "售罄 · {{count}}",
  "dispatch.preCheck.soldOutSource": "来源：今日需求 · 库存为 0 的商品",
  "dispatch.preCheck.loadFailed": "加载失败，这一项暂时无法核对，请重试",
  "dispatch.jobsListHint": "在配送单列表中取消或改期单张配送单。",
  "dispatch.board.title": "批次看板",
  "dispatch.board.nextGate": "下一个截止",
  "dispatch.board.yesterday": "昨天",
  "dispatch.board.today": "今天",
  "dispatch.board.dayLabel": "{{md}} {{weekday}}",
  "dispatch.board.collapsed": "{{from}} – {{to}} · 没有配送单，已折叠（有单就显示成普通行）",
  "dispatch.board.restDay": "{{date}} · 不配送",
  "dispatch.board.restDayBadge": "休息日",
  "dispatch.board.collapsedOne": "{{from}} · 没有配送单",
  "dispatch.board.error": "批次看板加载失败。",
  "dispatch.board.cell": "{{date}} {{stage}}：{{count}} 张配送单",
  "dispatch.board.cellNone": "{{date}} {{stage}}：无",
  "dispatch.board.stage.awaiting_dispatch": "待派单",
  "dispatch.board.stage.awaiting_assignment": "待分派",
  "dispatch.board.stage.awaiting_departure": "待出发",
  "dispatch.board.stage.en_route": "在路上",
  "dispatch.board.stage.delivered": "已送达",
  "dispatch.board.stage.exception_or_cancelled": "异常 / 取消",
  "dispatch.board.gate.packaging_cutoff": "配送单打印截止 {{at}}",
  "dispatch.board.gate.dispatch_cutoff": "派单截止 {{at}}",
  "dispatch.board.gate.delivery_window_end": "送达承诺窗结束 {{at}}",
  "dispatch.board.focus.title": "现在要处理",
  "dispatch.board.focus.allClear": "现在没有要处理的事。",
  "dispatch.phone.step.intake": "收单",
  "dispatch.phone.step.dispatch": "派单",
  "dispatch.phone.step.assign": "分派",
  "dispatch.phone.step.print": "打印",
  "dispatch.phone.step.deliver": "配送",
  "dispatch.phone.step.close": "收尾",
  "dispatch.phone.headline.lateSuffix_one": "，{{count}} 位司机预计晚于 {{time}}",
  "dispatch.phone.headline.lateSuffix_other": "，{{count}} 位司机预计晚于 {{time}}",
  "dispatch.phone.hero.lateSub_one": "按 {{provider}} ETA · 剩余 {{count}} 站 · 司机已带餐出发，这里只提醒",
  "dispatch.phone.hero.lateSub_other": "按 {{provider}} ETA · 剩余 {{count}} 站 · 司机已带餐出发，这里只提醒",
  "dispatch.phone.drivers.title": "司机",
  "dispatch.phone.drivers.legend": "预计收尾 · 截止 {{time}}",
  "dispatch.phone.hero.viewDriverStops": "看 {{name}} 的路线",
  "dispatch.phone.stops.back": "返回",
  "dispatch.phone.stops.lateBanner_one": "{{count}} 单预计晚于 {{time}}（送达时段结束）",
  "dispatch.phone.stops.lateBanner_other": "{{count}} 单预计晚于 {{time}}（送达时段结束）",
  "dispatch.phone.stops.sameAddress_one": "同一地址 {{count}} 单",
  "dispatch.phone.stops.sameAddress_other": "同一地址 {{count}} 单",
  "dispatch.phone.stops.doneSummary": "已送达 {{count}} 单 · 最近一单 {{time}}",
  "dispatch.phone.stops.loadFailed": "预计时间读取失败",
  "dispatch.phone.stops.notFound": "今天的配送里没有这位司机。",
  "dispatch.phone.stopsView.label": "查看方式",
  "dispatch.phone.stopsView.list": "列表",
  "dispatch.phone.stopsView.map": "地图",
  "dispatch.phone.stopsView.mapEmpty": "这位司机没有能在地图上显示的配送单。",
  "dispatch.phone.inbox.title_one": "{{count}} 件事等你看",
  "dispatch.phone.inbox.title_other": "{{count}} 件事等你看",
  "dispatch.phone.inbox.empty": "现在没有事等你看。",
  "dispatch.phone.inbox.loadError": "收件箱读取失败",
  "dispatch.phone.inbox.openOrder": "打开订单",
  "dispatch.phone.inbox.changeJoin": "、",
  "dispatch.phone.inbox.change.address": "改了地址",
  "dispatch.phone.inbox.change.quantity": "改了数量",
  "dispatch.phone.inbox.change.cancel": "取消了订单",
  "dispatch.phone.inbox.change.other": "其他变更",
  "dispatch.phone.search.entry": "订单号、客户姓名或电话",
  "dispatch.phone.search.inputLabel": "搜索配送单",
  "dispatch.phone.search.back": "返回现在",
  "dispatch.phone.search.today_one": "今天 · {{count}} 单",
  "dispatch.phone.search.today_other": "今天 · {{count}} 单",
  "dispatch.phone.search.later_one": "之后 · {{count}} 单",
  "dispatch.phone.search.later_other": "之后 · {{count}} 单",
  "dispatch.phone.search.phoneTail": "电话尾号 {{tail}}",
  "dispatch.phone.search.empty": "今天及之后没有找到配送单",
  "dispatch.phone.search.truncated": "只显示前 {{shown}} 单，共 {{total}} 单；多输几个字缩小范围。",
  "dispatch.board.focus.badge.gate": "截止",
  "dispatch.board.focus.badge.mustFix": "必须先处理",
  "dispatch.board.focus.badge.handled": "已处理",
  "dispatch.board.focus.badge.canStart": "可以开始",
  "dispatch.board.focus.badge.attention": "需注意",
  "dispatch.board.focus.badge.progress": "进度",
  "dispatch.board.focus.badge.exception": "异常",
  "dispatch.board.focus.badge.reminder": "提醒",
  "dispatch.board.focus.gateDispatch.title": "今天 {{day}} · 派单 {{from}}–{{to}}",
  "dispatch.board.focus.gateDispatch.titleCutoffOnly": "今天 {{day}} · 派单截止 {{at}}",
  "dispatch.board.focus.gateDispatch.subSoon_one": "{{count}} 分钟后打包截止。",
  "dispatch.board.focus.gateDispatch.subSoon_other": "{{count}} 分钟后打包截止。",
  "dispatch.board.focus.gateDispatch.subLater": "{{at}} 打包截止。",
  "dispatch.board.focus.gateDispatch.subPackClosed": "打包已截止，{{at}} 前派完。",
  "dispatch.board.focus.gateDispatch.subPastCutoff": "已过派单截止。",
  "dispatch.board.focus.gateDispatch.subByCutoff": "{{at}} 前派完。",
  "dispatch.board.focus.preflight.title_one": "{{count}} 张配送单的订单已取消",
  "dispatch.board.focus.preflight.title_other": "{{count}} 张配送单的订单已取消",
  "dispatch.board.focus.preflight.titleNotFound_one": "{{count}} 张配送单的订单不存在",
  "dispatch.board.focus.preflight.titleNotFound_other": "{{count}} 张配送单的订单不存在",
  "dispatch.board.focus.preflight.titleMixed_one": "{{count}} 张配送单的订单已取消或不存在",
  "dispatch.board.focus.preflight.titleMixed_other": "{{count}} 张配送单的订单已取消或不存在",
  "dispatch.board.focus.preflight.sub": "不处理的话派单那一批会失败。",
  "dispatch.board.focus.preflightHandled.title": "预检异常已处理",
  "dispatch.board.focus.preflightHandled.sub_one": "已取消 {{count}} 张配送单。",
  "dispatch.board.focus.preflightHandled.sub_other": "已取消 {{count}} 张配送单。",
  "dispatch.board.focus.gateAssign.title_one": "{{provider}} 里还有 {{count}} 个司机任务没分派",
  "dispatch.board.focus.gateAssign.title_other": "{{provider}} 里还有 {{count}} 个司机任务没分派",
  "dispatch.board.focus.gateAssign.sub": "{{at}} 司机取餐。分派在 {{provider}} 做。",
  "dispatch.board.focus.printable.title": "{{count}} 张已分派，可以按司机打印",
  "dispatch.board.focus.printable.subRemaining": "剩下的分派后补打。",
  "dispatch.board.focus.printable.subNoneLeft": "{{at}} 司机取餐前打完。",
  "dispatch.board.focus.unmapped.title_one": "{{count}} 站分给了本地没有的司机",
  "dispatch.board.focus.unmapped.title_other": "{{count}} 站分给了本地没有的司机",
  "dispatch.board.focus.unmapped.sub": "从 {{provider}} 导入司机。",
  "dispatch.board.focus.late.title": "{{name}} 预计 {{at}} 送完",
  "dispatch.board.focus.late.titleMany_one": "{{count}} 位司机预计晚于 {{at}} 送完",
  "dispatch.board.focus.late.titleMany_other": "{{count}} 位司机预计晚于 {{at}} 送完",
  "dispatch.board.focus.late.sub": "只读，处理在 {{provider}}。",
  "dispatch.board.focus.gateDeliver.title": "送达 · {{at}} 前",
  "dispatch.board.focus.gateDeliver.subEta": "预计 {{at}} 全部送完。",
  "dispatch.board.focus.gateDeliver.subReadOnly": "只读，处理在 {{provider}}。",
  "dispatch.board.focus.progress.title": "{{delivered}} / {{total}} 已送达",
  "dispatch.board.focus.progress.subDrivers_one": "{{count}} 位司机在路上。",
  "dispatch.board.focus.progress.subDrivers_other": "{{count}} 位司机在路上。",
  "dispatch.board.focus.progress.subClosed": "今天已收尾。",
  "dispatch.board.focus.exception.title_one": "{{count}} 张配送单异常",
  "dispatch.board.focus.exception.title_other": "{{count}} 张配送单异常",
  "dispatch.board.focus.exception.sub": "已进运营收件箱。",
  "dispatch.board.focus.nextBatch.title_one": "{{day}} · {{count}} 张在收单",
  "dispatch.board.focus.nextBatch.title_other": "{{day}} · {{count}} 张在收单",
  "dispatch.board.focus.nextBatch.sub_one": "现在 {{count}} 张待派单。",
  "dispatch.board.focus.nextBatch.sub_other": "现在 {{count}} 张待派单。",
  "dispatch.board.focus.straggler.title": "{{count}} 张单还在「{{step}}」",
  "dispatch.board.focus.straggler.sub": "已过 {{at}} 截止，其余单已往后走。",
  "dispatch.board.loading": "批次看板加载中…",
  "dispatch.board.batchWord.shipping_date": "配送日",
  "dispatch.board.batchHint_one": "今天起 {{count}} 天 · 昨天留在顶部",
  "dispatch.board.batchHint_other": "今天起 {{count}} 天 · 昨天留在顶部",
  "dispatch.board.batchHintShifted_one": "{{from}} 起 {{count}} 天",
  "dispatch.board.batchHintShifted_other": "{{from}} 起 {{count}} 天",
  "dispatch.board.intake": "订单进来",
  "dispatch.board.intakeWho": "Shopify",
  "dispatch.board.bypass": "旁路",
  "dispatch.board.columnAction.dispatch": "派单",
  "dispatch.board.columnAction.assign_driver": "分派司机",
  "dispatch.board.columnAction.depart": "出发（第一站开始）",
  "dispatch.board.columnAction.deliver": "送达",
  "dispatch.board.nextGateHint": "时间规则来自流程设置",
  "dispatch.board.rowTotal_one": "{{count}} 张配送单",
  "dispatch.board.rowTotal_other": "{{count}} 张配送单",
  "dispatch.board.collapsedWeekend": "{{from}} – {{to}} 周末 · 没有配送单，已折叠（有单就显示成普通行）",
  "dispatch.board.copy.anomalies_one": "{{count}} 项预检异常",
  "dispatch.board.copy.anomalies_other": "{{count}} 项预检异常",
  "dispatch.board.copy.afterPackaging": "{{at}} 后派",
  "dispatch.board.copy.soldOut_one": "{{count}} 个商品售罄",
  "dispatch.board.copy.soldOut_other": "{{count}} 个商品售罄",
  "dispatch.board.copy.assigning": "{{provider}} 分派中",
  "dispatch.board.copy.printable": "可以打印",
  "dispatch.board.copy.lateDrivers": "{{count}} 位偏晚",
  "dispatch.board.copy.closed": "已收尾",
  "dispatch.board.copy.closedLate_one": "晚于 {{at}}：{{count}} 张",
  "dispatch.board.copy.closedLate_other": "晚于 {{at}}：{{count}} 张",
  "dispatch.board.copy.dispatchWindow": "派单 · {{from}}–{{to}}",
  "dispatch.board.copy.dispatchWindowOn": "派单 · {{date}} {{from}}–{{to}}",
  "dispatch.board.copy.dispatchWindowSameDay": "派单 · 当天 {{from}}–{{to}}",
  "dispatch.board.copy.dispatchCutoffOnly": "派单 · 截止 {{at}}",
  "dispatch.board.copy.dispatchCutoffOnlyOn": "派单 · {{date}} 截止 {{at}}",
  "dispatch.board.copy.dispatchCutoffOnlySameDay": "派单 · 当天截止 {{at}}",
  "dispatch.board.copy.opensInMinutes_one": "{{count}} 分钟后打开 · 打包截止之后派",
  "dispatch.board.copy.opensInMinutes_other": "{{count}} 分钟后打开 · 打包截止之后派",
  "dispatch.board.copy.opensAt": "{{at}} 打开 · 打包截止之后派",
  "dispatch.board.copy.openUntil": "已打开 · {{at}} 前派完",
  "dispatch.board.copy.dispatchPassed": "已过派单截止",
  "dispatch.board.copy.dispatchByCutoff": "{{at}} 前派完",
  "dispatch.board.copy.collecting": "收单中",
  "dispatch.board.copy.assignBy": "分派司机 · {{at}} 取餐前",
  "dispatch.board.copy.assignRemaining": "{{provider}} 里还差 {{count}} 个",
  "dispatch.board.copy.departAfter": "出发 · {{at}} 取餐后",
  "dispatch.board.copy.departPrintable": "{{count}} 张可以打印",
  "dispatch.board.copy.deliverBy": "送达 · {{at}} 前",
  "dispatch.board.copy.lateDriversEta_one": "{{count}} 位司机预计 {{at}}",
  "dispatch.board.copy.lateDriversEta_other": "{{count}} 位司机预计 {{at}}",
  "dispatch.board.copy.etaDone": "预计 {{at}} 送完",
  "dispatch.pane.countBadge_one": "{{count}} 张",
  "dispatch.pane.countBadge_other": "{{count}} 张",
  "dispatch.pane.empty.title": "{{day}} 现在没有「{{stage}}」的配送单",
  "dispatch.pane.empty.noJobs": "这一批还没有配送单。",
  "dispatch.pane.empty.allDispatched": "这一批已经全部派出。",
  "dispatch.pane.empty.notHereYet": "这一批还没走到这一步，或者已经全部走过去了。",
  "dispatch.pane.assignment.import": "从 Onfleet 导入司机",
  "dispatch.pane.assignment.importConfirmTitle": "从 Onfleet 导入司机？",
  "dispatch.pane.assignment.importConfirm": "读取 Onfleet 当前的司机名单，更新本地司机列表。不会向 Onfleet 写入任何内容。",
  "dispatch.pane.assignment.importDone": "新增 {{created}}，更新 {{updated}}，无效 {{invalid}}；{{backfilled}} 个司机任务补上了司机。",
  "dispatch.pane.assignment.importFailed": "导入司机失败",
  "dispatch.pane.assignment.progressTitle": "Onfleet 里的分派进度",
  "dispatch.pane.assignment.progressHint": "每收到 taskAssigned webhook 更新",
  "dispatch.pane.assignment.progressCount_one": "/ {{count}} 个司机任务已有司机",
  "dispatch.pane.assignment.progressCount_other": "/ {{count}} 个司机任务已有司机",
  "dispatch.pane.assignment.openOnfleet": "在 Onfleet 中分派 ↗",
  "dispatch.pane.assignment.unassigned": "Onfleet 里还没分派",
  "dispatch.pane.assignment.unmapped": "已分派，但本地没有这位司机",
  "dispatch.pane.assignment.stops_one": "{{count}} 站",
  "dispatch.pane.assignment.stops_other": "{{count}} 站",
  "dispatch.pane.assignment.beforePickup": "{{time}} 取餐前",
  "dispatch.pane.assignment.newDriverNotImported": "新司机未导入",
  "dispatch.pane.assignment.printTitle": "打印可以先开始",
  "dispatch.pane.assignment.printBody": "已经有司机的配送单在「待出发」里，可以先按司机打印。剩下的分派后补打。",
  "dispatch.pane.assignment.goReady": "去「待出发」打印",
  "dispatch.pane.assignment.loadFailed": "读取分派进度失败",
  "dispatch.pane.departure.title": "按司机打印配送单",
  "dispatch.pane.departure.subtitle": "一张配送单一张卡 · 101 × 50 mm · 每页 {{perSheet}} 张",
  "dispatch.pane.departure.pages_one": "{{count}} 页",
  "dispatch.pane.departure.pages_other": "{{count}} 页",
  "dispatch.pane.departure.print": "打印",
  "dispatch.pane.departure.assignedOn": "{{day}} · 已分派 {{count}} 张",
  "dispatch.pane.departure.printAll": "打印已分派的 {{count}} 张",
  "dispatch.pane.departure.note": "系统不记录是否已打印，所以这一列不会打勾；司机出发（第一个 taskStarted）后自动移到「{{enRoute}}」。",
  "dispatch.pane.departure.printTitle": "{{day}} 配送单打印",
  "dispatch.pane.departure.empty": "没有可以打印的配送单",
  "dispatch.pane.departure.loadFailed": "读取配送单打印内容失败",
  "dispatch.pane.departure.noAccess": "没有查看配送单打印内容的权限",
  "dispatch.pane.exception.reason.preflight_order_cancelled": "订单在 Shopify 已取消，派单前在预检时取消",
  "dispatch.pane.exception.reason.operator_before_dispatch": "派单前由运营取消",
  "dispatch.pane.exception.reason.operator_after_dispatch": "派单后由运营取消，Onfleet 司机任务已删除",
  "dispatch.pane.exception.reason.shopify_order_cancelled": "订单在 Shopify 已取消，系统自动取消",
  "dispatch.pane.exception.reason.shopify_date_removed": "订单在 Shopify 改单或退款后不再含这一天，系统自动取消",
  "dispatch.pane.exception.reason.delivery_failed": "Onfleet 报告送达失败，已进运营收件箱",
  "dispatch.pane.exception.reason.unknown": "没有记录原因",
  "dispatch.pane.exception.failedTitle": "送达失败时",
  "dispatch.pane.exception.failedBody": "：配送单进入异常并进运营收件箱（派单或送达失败）。在 Onfleet 删除这个司机任务后，配送单回到「{{pending}}」，就可以改期到别的批次。",
  "dispatch.pane.exception.loadFailed": "读取异常 / 取消配送单失败",
  "dispatch.pane.enRoute.etaTodayOnly": "只有今天有 Onfleet ETA。",
  "dispatch.pane.enRoute.kpi.delivered": "已送达",
  "dispatch.pane.enRoute.kpi.deliveredOf_one": "/ {{count}} 张配送单",
  "dispatch.pane.enRoute.kpi.deliveredOf_other": "/ {{count}} 张配送单",
  "dispatch.pane.enRoute.kpi.drivers_one": "{{count}} 位司机",
  "dispatch.pane.enRoute.kpi.drivers_other": "{{count}} 位司机",
  "dispatch.pane.enRoute.kpi.lateTitle": "预计晚于 {{time}}",
  "dispatch.pane.enRoute.kpi.lateValue_one": "{{count}} 位",
  "dispatch.pane.enRoute.kpi.lateValue_other": "{{count}} 位",
  "dispatch.pane.enRoute.kpi.byOnfleetEta": "按 Onfleet ETA",
  "dispatch.pane.enRoute.kpi.failed": "送达失败",
  "dispatch.pane.enRoute.kpi.byJobStatus": "按配送单状态",
  "dispatch.pane.enRoute.lateBy": "晚 {{count}} 分钟",
  "dispatch.pane.enRoute.stops_one": "{{done}}/{{count}} 站",
  "dispatch.pane.enRoute.stops_other": "{{done}}/{{count}} 站",
  "dispatch.pane.enRoute.unknownDriver": "本地没有的司机",
  "dispatch.pane.enRoute.readOnlyBefore": "只读：司机带着这车的餐出发，路上不换人。需要处理就",
  "dispatch.pane.enRoute.openOnfleet": "在 Onfleet 中查看 ↗",
  "dispatch.pane.enRoute.readOnlyAfter": "，改动会经 webhook 回到这里。",
  "dispatch.pane.enRoute.loadFailed": "在路上的司机汇总读取失败",
  "customer.listTitle": "客户",
  "customer.listDescription": "已同步到管理台的 Shopify 客户。",
  "product.listTitle": "产品",
  "product.listDescription": "可用于配送的 Shopify 产品。",
  "order.listTitle": "订单",
  "order.listDescription": "Shopify 订单及其配送状态。",
  "driver.listTitle": "司机",
  "driver.listDescription": "Onfleet 配送司机。",
  "driverProfiles.label": "司机画像",
  "driverProfiles.listTitle": "司机画像",
  "driverProfiles.listDescription": "查看学习值并维护排线规划使用的调度纠偏值。",
  "driverProfiles.field.driver": "司机",
  "driverProfiles.field.zones": "邮编权重 Top 5",
  "driverProfiles.field.dailyRange": "每日单量区间",
  "driverProfiles.field.endAnchor": "收工终点",
  "driverProfiles.field.departureOffset": "出发偏移（分钟）",
  "driverProfiles.field.p25": "P25",
  "driverProfiles.field.median": "中位数",
  "driverProfiles.field.p75": "P75",
  "driverProfiles.field.lat": "纬度",
  "driverProfiles.field.lng": "经度",
  "driverProfiles.field.address": "地址",
  "driverProfiles.field.learnedFrom": "样本量与窗口",
  "driverProfiles.searchPlaceholder": "搜索司机画像...",
  "driverProfiles.coldStart": "冷启动 — 暂无学习画像",
  "driverProfiles.noSupportedZones": "暂无达到最小支持度的邮编",
  "driverProfiles.zoneWeight": "{{zip}} ×{{weight}}",
  "driverProfiles.dailyRangeValue": "{{p25}}–{{p75}}，中位 {{median}}",
  "driverProfiles.provenance_one": "{{count}} 单 · {{start}}–{{end}}",
  "driverProfiles.provenance_other": "{{count}} 单 · {{start}}–{{end}}",
  "driverProfiles.relearn": "重新学习",
  "driverProfiles.relearning": "学习中...",
  "driverProfiles.relearnSuccessTitle": "画像学习完成",
  "driverProfiles.relearnSuccess": "已从 {{jobs}} 张完成的配送单更新 {{drivers}} 位司机。",
  "driverProfiles.relearnErrorTitle": "画像学习失败",
  "driverProfiles.noEffective": "暂无有效画像",
  "driverProfiles.corrected": "已纠偏",
  "driverProfiles.endAnchorValueWithLabel": "{{label}}",
  "driverProfiles.endAnchorValueCoordsOnly": "{{lat}}, {{longitude}}",
  "driverProfiles.endAnchorAddressPlaceholder": "请输入司机惯常的收工地址",
  "driverProfiles.offsetPositive": "+{{value}} 分钟",
  "driverProfiles.offsetValue": "{{value}} 分钟",
  "driverProfiles.editAria": "编辑 {{driver}} 的纠偏值",
  "driverProfiles.editFormAria": "{{driver}} 的纠偏编辑器",
  "driverProfiles.save": "保存纠偏值",
  "driverProfiles.saving": "保存中...",
  "driverProfiles.clearRestore": "清除并恢复学习值",
  "driverProfiles.clearAria": "清除 {{driver}} 的{{field}}纠偏",
  "driverProfiles.clearField.zones": "区域",
  "driverProfiles.clearField.dailyRange": "每日单量区间",
  "driverProfiles.clearField.endAnchor": "收工终点",
  "driverProfiles.clearField.departureOffset": "出发偏移",
  "driverProfiles.zoneZipAria": "邮编 {{index}}",
  "driverProfiles.zoneWeightAria": "权重 {{index}}",
  "driverProfiles.removeZoneAria": "移除区域 {{index}}",
  "driverProfiles.addZone": "添加邮编",
  "driverProfiles.validation.zones": "邮编必须为五位数字，权重必须大于 0 且不超过 1。",
  "driverProfiles.validation.dailyRange": "P25、中位数和 P75 必须为按升序排列的正整数。",
  "driverProfiles.validation.endAnchor": "请输入有效的经纬度，标签不得超过 120 个字符。",
  "driverProfiles.validation.departureOffset": "出发偏移必须为 -120 到 120 之间的整数。",
  "driverProfiles.saveSuccessTitle": "画像已纠偏",
  "driverProfiles.saveSuccess": "有效画像已刷新。",
  "driverProfiles.saveErrorTitle": "画像纠偏保存失败",
  "driverProfiles.empty": "暂无司机",
  "ingredient.listTitle": "原料",
  "ingredient.listDescription": "各配方使用的原料。",
  "supplier.listTitle": "供应商",
  "supplier.listDescription": "原料供应商及其联系方式。",
  "dish.listTitle": "菜品",
  "dish.listDescription": "菜单菜品及其配方。",
  "combo.listTitle": "套餐",
  "combo.listDescription": "由菜品组成的套餐。",
  "job.listTitle": "配送单",
  "job.listDescription": "派出并跟踪。",
  "webhook.listTitle": "Webhook 事件",
  "webhook.listDescription": "来自 Shopify 与 Onfleet 的入站 webhook 事件。",
  "menu_plan.listTitle": "菜单计划",
  "menu_plan.listDescription": "每周菜单计划及其已发布条目。",
  "nav.tenantSettings": "集成与设置",
  "nav.deliveryFlowSettings": "配送流程",
  "auditWebhooks.tab.operations": "操作审计",
  "auditWebhooks.tab.changes": "数据变更",
  "auditWebhooks.tab.events": "Webhook 事件",
  "auditWebhooks.tab.failures": "Webhook 失败",
  "auditWebhooks.tab.health": "Webhook 健康",
  "webhookFailures.row.delete": "删除",
  "webhookFailures.detail.title": "失败详情",
  "webhookFailures.detail.status": "状态",
  "webhookFailures.detail.resolved": "已解决",
  "webhookFailures.detail.unresolved": "未解决",
  "webhookFailures.detail.traceId": "追踪 ID",
  "webhookFailures.detail.rawPayload": "原始载荷",
  "webhookFailures.detail.relatedEvent": "关联 Webhook 事件",
  "webhookFailures.detail.viewEvent": "查看事件",
  "webhookFailures.detail.noRelatedEvent": "无关联 Webhook 事件",
  "webhookFailures.selfHeal.self_healed": "已自愈",
  "webhookFailures.selfHeal.needs_review": "仍需人工",
  "webhookFailures.detail.selfHeal": "自愈判定",
  "webhookFailures.detail.selfHealCriterion.provider_event_id": "同一条服务方事件后来已成功入库。",
  "webhookFailures.detail.selfHealCriterion.payload_hash": "同样载荷的后续投递已成功入库。",
  "webhookFailures.detail.selfHealNeedsReview": "尚未找到与之对应的成功投递。",
  "webhookFailures.detail.viewMatchedEvent": "查看成功的那条事件",
  "webhookFailures.detail.diagnosis": "错误与负载",
  "webhookFailures.detail.loading": "正在加载详情…",
  "webhookFailures.detail.loadError": "无法加载失败详情。详情：{{detail}}",
  "webhookFailures.detail.openFullPage": "打开完整页面",
  "webhookFailures.detail.backToList": "返回失败列表",
  "webhookFailures.detail.notFound": "找不到该 Webhook 失败记录。",
  "webhookFailures.delete.confirmTitle": "删除该失败记录？",
  "webhookFailures.delete.confirmMessage": "这将永久删除该失败记录，操作不可恢复。",
  "webhookFailures.delete.success.title": "已删除",
  "webhookFailures.delete.success.body": "失败记录已永久删除。",
  "webhookFailures.delete.error.title": "删除失败",
  "webhookFailures.delete.error.unknown": "无法删除失败记录。详情：{{detail}}",
  "webhookFailures.bulkDelete.submit": "删除所选",
  "webhookFailures.bulkDelete.limitHint": "单次最多删除 {{max}} 条；仅删除前 {{max}} 条。",
  "webhookFailures.bulkDelete.confirmTitle_one": "删除所选的 {{count}} 条失败记录？",
  "webhookFailures.bulkDelete.confirmTitle_other": "删除所选的 {{count}} 条失败记录？",
  "webhookFailures.bulkDelete.confirmMessage": "这将永久删除所选的失败记录，操作不可恢复。",
  "webhookFailures.bulkDelete.success.title": "批量删除完成",
  "webhookFailures.bulkDelete.success.summary_one": "已删除 {{count}} 条失败记录。",
  "webhookFailures.bulkDelete.success.summary_other": "已删除 {{count}} 条失败记录。",
  "webhookFailures.bulkDelete.error.title": "批量删除失败",
  "webhookFailures.bulkDelete.error.unknown": "无法删除所选失败记录。详情：{{detail}}",
  "webhookFailures.purge.button": "清空全部",
  "webhookFailures.purge.confirmTitle": "清空全部失败记录？",
  "webhookFailures.purge.confirmMessage": "这将永久删除全部 Webhook 失败记录——包括所有已解决的历史记录，而不仅是当前未解决的 {{count}} 条。历史记录总量可能远多于此。操作不可恢复。",
  "webhookFailures.purge.success.title": "已清空",
  "webhookFailures.purge.success.summary_one": "已删除 {{count}} 条失败记录。",
  "webhookFailures.purge.success.summary_other": "已删除 {{count}} 条失败记录。",
  "webhookFailures.purge.error.title": "清空失败",
  "webhookFailures.purge.error.unknown": "无法清空失败记录。详情：{{detail}}",
  "job.field.driverName": "司机",
  "job.field.driverId": "司机 ID",
  "nav.analytics": "数据分析",
  "analytics.page.title": "数据分析",
  "analytics.page.subtitle": "每周经营报告与临时分析。",
  "analytics.details.title": "明细数据",
  "analytics.sync.staleTitle": "分析数据可能已过期",
  "analytics.sync.staleDescription": "最近一次上游同步未成功。上次成功同步时间：{{time}}。",
  "analytics.sync.unavailableTitle": "无法确认分析数据时效",
  "analytics.sync.unavailableDescription": "尚无成功的上游同步记录，不得把报告视为最新数据。",
  "analytics.freshness.current": "数据已同步",
  "analytics.freshness.stale": "数据可能已过期",
  "analytics.generate.title": "生成临时报告",
  "analytics.generate.selectRange": "选择日期范围",
  "analytics.generate.button": "生成报告",
  "analytics.generate.runningShort": "正在生成…",
  "analytics.generate.successTitle": "报告已生成",
  "analytics.generate.successMessage": "临时报告现已可读。",
  "analytics.generate.errorTitle": "报告生成失败",
  "analytics.generate.errorMessage": "无法生成报告。请检查同步时效后重试。",
  "analytics.archive.loading": "正在加载分析报告…",
  "analytics.archive.error": "无法加载分析报告。",
  "analytics.archive.emptyDescription": "定时或临时生成成功后，报告会显示在这里。",
  "analytics.report.generatedAt": "生成于 {{time}}",
  "analytics.report.loading": "正在加载报告…",
  "analytics.report.error": "无法加载这份报告。",
  "analytics.period.weekly": "周报",
  "analytics.period.adhoc": "临时",
  "analytics.value.notAvailable": "暂无",
  "analytics.metrics.growth": "增长",
  "analytics.metrics.metric": "指标",
  "analytics.metrics.orders": "订单",
  "analytics.metrics.revenue": "收入",
  "analytics.metrics.orderingCustomers": "下单客户",
  "analytics.metrics.current": "当前周期",
  "analytics.metrics.previousPeriod": "上一周期",
  "analytics.metrics.periodChange": "环比变化",
  "analytics.metrics.previousYear": "去年同期",
  "analytics.metrics.yearChange": "同比变化",
  "analytics.metrics.activation": "激活",
  "analytics.metrics.cohortRange": "客户群：{{start}} 至 {{end}}",
  "analytics.metrics.attained": "{{attained}} / {{total}} 位客户达到目标。",
  "analytics.metrics.activationRate": "激活率：{{value}}",
  "analytics.metrics.matching": "菜单匹配",
  "analytics.metrics.matchingCounts": "{{active}} 位活跃客户中覆盖 {{covered}} 位，共提供 {{dishes}} 道菜品。",
  "analytics.metrics.coverageRate": "覆盖率：{{value}}",
  "analytics.metrics.uncovered": "未覆盖客户：{{count}}",
  "analytics.metrics.retention": "留存",
  "analytics.metrics.activeCore": "活跃核心客户：{{count}}",
  "analytics.metrics.checkpoint": "观察点",
  "analytics.metrics.atRisk": "风险样本",
  "analytics.metrics.eventualReturn": "最终回购",
  "analytics.metrics.rate": "比率",
  "analytics.metrics.miniChart": "迷你图",
  "analytics.metrics.days_one": "{{count}} 天",
  "analytics.metrics.days_other": "{{count}} 天",
  "analytics.metrics.alerts": "预警",
  "analytics.metrics.watchlist": "预警客户：{{count}}",
  "analytics.metrics.leverage": "订单杠杆",
  "analytics.metrics.orderCount": "订单：{{count}}",
  "analytics.metrics.itemCount": "商品件数：{{count}}",
  "analytics.metrics.averageItems": "单均商品件数：{{value}}",
  "analytics.metrics.averageItemsLabel": "单均商品件数",
  "analytics.narrative.title": "AI 解读",
  "analytics.narrative.empty": "这份报告没有归档经营解读，请以确定性指标为准。",
  "analytics.trace.title": "计算追踪",
  "analytics.trace.ariaLabel": "分析调用轨迹",
  "analytics.list.label": "报告",
  "analytics.list.weekly": "周报",
  "analytics.list.adhoc": "临时报告",
  "analytics.list.generatedOn": "生成于 {{date}}",
  "analytics.archive.emptyTitle": "暂无报告",
  "analytics.report.weeklyLabel": "{{year}} 第 {{week}} 周 · {{range}}",
  "analytics.report.adhocLabel_one": "{{range}} · {{count}} 天",
  "analytics.report.adhocLabel_other": "{{range}} · {{count}} 天",
  "analytics.delete.button": "删除",
  "analytics.delete.ariaLabel": "删除 {{label}}",
  "analytics.delete.confirmTitle": "删除这份临时报告？",
  "analytics.delete.confirmMessage": "将删除「{{label}}」。之后可以为同一日期范围重新生成报告。",
  "analytics.delete.successTitle": "报告已删除",
  "analytics.delete.errorTitle": "报告删除失败",
  "analytics.delete.errorMessage": "请稍后重试。",
  "analytics.generate.description": "选择要分析的日期范围，生成可能需要几分钟。",
  "analytics.generate.blockedStale": "最近一次上游同步失败，数据可能已过期，暂不能生成报告。",
  "analytics.generate.blockedUnavailable": "尚无成功的上游同步记录，暂不能生成报告。",
  "analytics.generate.blockedRange": "请选择开始和结束日期。",
  "analytics.performance.title": "本期表现",
  "analytics.performance.periodChange": "环比",
  "analytics.performance.yearChange": "同比",
  "analytics.performance.periodWindow": "环比 vs {{range}}",
  "analytics.performance.yearWindow": "同比 vs {{range}}",
  "analytics.performance.noComparison": "无对比",
  "analytics.performance.itemsSold_one": "共售出 {{n}} 件",
  "analytics.performance.itemsSold_other": "共售出 {{n}} 件",
  "analytics.health.title": "客户健康",
  "analytics.health.asOf": "截至 {{time}} 的快照，与报告期无关；生成后的数据（如退款）可能使其变化。",
  "analytics.health.activation": "激活率",
  "analytics.health.activationDetail": "{{attained}} / {{total}} 位新客达到首月目标",
  "analytics.health.activationCohort": "客户群 {{range}}",
  "analytics.health.coverage": "菜单覆盖率",
  "analytics.health.coverageDetail": "{{covered}} / {{active}} 位活跃客户被 {{dishes}} 道菜覆盖",
  "analytics.health.retention": "核心客户回购曲线",
  "analytics.health.retentionDescription_one": "各观察点的最终回购率 · 活跃核心客户 {{n}} 位",
  "analytics.health.retentionDescription_other": "各观察点的最终回购率 · 活跃核心客户 {{n}} 位",
  "analytics.health.retentionRate": "回购率",
  "analytics.health.retentionSample": "样本 n = {{n}}",
  "analytics.health.watchlist": "流失预警",
  "analytics.health.watchlistCustomers": "位客户",
  "analytics.health.watchlistSpend": "累计消费",
  "analytics.health.watchlistSpendHint": "这些客户至今的累计消费总额，不是风险金额。",
  "analytics.narrative.failureTitle": "这份报告的 AI 解读未能生成",
  "analytics.narrative.failureHint": "上方指标为确定性计算，不受影响。",
  "analytics.narrative.failure.credentialMissing": "AI 服务凭据未配置。",
  "analytics.narrative.failure.apiError": "AI 服务调用出错。",
  "analytics.narrative.failure.refusal": "AI 模型拒绝生成解读。",
  "analytics.narrative.failure.malformedOutput": "AI 输出格式不符合要求，已被丢弃。",
  "analytics.narrative.failure.tokenBudgetExhausted": "AI 模型在完成前用尽了输出额度。",
  "analytics.narrative.failure.untraceableNumber": "解读引用了指标中无法追溯的数字，已被丢弃。",
  "analytics.narrative.failure.missingFollowup": "解读未跟进上期建议，已被丢弃。",
  "analytics.narrative.failure.unknown": "AI 解读生成失败，详情见计算追踪。",
  "analytics.metrics.lifetimeSpend": "累计消费：{{value}}",
  "app.newVersion.message": "控制台已部署新版本，刷新后即可使用。",
  "app.newVersion.reload": "立即刷新",
  "tenants.loading": "加载中…",
  "tenants.settingsPage.title": "集成与设置",
  "tenants.settingsPage.subtitle": "当前租户的凭据与设置。",
  "tenants.integrations.loadError": "集成状态加载失败。",
  "tenants.integrations.shopify.title": "Shopify",
  "tenants.integrations.onfleet.title": "Onfleet",
  "tenants.integrations.shopify.liveWarning": "保存后会立即替换生产环境真实 Shopify 流量所用的凭据。",
  "tenants.integrations.onfleet.liveWarning": "保存后会立即替换生产环境真实 Onfleet 流量所用的凭据。Onfleet 只校验密钥可用，不校验它是否属于同一组织。",
  "tenants.integrations.field.verifiedAt": "校验时间",
  "tenants.integrations.source.tenant": "来自租户配置",
  "tenants.integrations.source.none": "未配置",
  "tenants.integrations.shopify.kind.label": "凭据类型",
  "tenants.integrations.shopify.kind.legacy_token": "Admin API 访问令牌",
  "tenants.integrations.shopify.kind.client_credentials": "客户端凭据",
  "tenants.integrations.shopify.secretRequired": "API 密钥与 Webhook 密钥至少填一项，否则无法校验 webhook。",
  "tenants.integrations.save": "校验并保存",
  "tenants.integrations.saving": "校验中…",
  "tenants.integrations.saved": "凭据已校验并保存。",
  "tenants.integrations.saveFailed": "保存失败：{{message}}",
  "tenants.integrations.required": "请填写所有必填项。",
  "tenants.integrations.registerWebhooks": "注册 webhook",
  "tenants.integrations.registering": "注册中…",
  "tenants.integrations.registerHint": "在此保存凭据后可用。",
  "tenants.integrations.registerFailed": "注册 webhook 失败：{{message}}",
  "tenants.integrations.webhooks.created": "新建",
  "tenants.integrations.webhooks.existing": "已存在",
  "tenants.integrations.webhooks.none": "无",
  "tenants.integrations.edit": "编辑凭据",
  "tenants.integrations.cancel": "取消",
  "tenants.integrations.notSet": "未设置",
  "tenants.integrations.fieldName.shopDomain": "店铺域名",
  "tenants.integrations.fieldName.accessToken": "访问令牌",
  "tenants.integrations.fieldName.apiSecret": "API 密钥",
  "tenants.integrations.fieldName.webhookSecret": "Webhook 密钥",
  "tenants.integrations.fieldName.clientId": "客户端 ID",
  "tenants.integrations.fieldName.clientSecret": "客户端密钥",
  "tenants.integrations.fieldName.apiKey": "API 密钥",
  "tenants.integrations.fieldName.organizationId": "组织 ID",
  "tenants.integrations.webhooks.title": "Webhook 订阅",
  "tenants.integrations.webhooks.topic": "主题",
  "tenants.integrations.webhooks.url": "地址",
  "tenants.integrations.webhooks.target": "指向",
  "tenants.integrations.webhooks.ours": "本站",
  "tenants.integrations.webhooks.elsewhere": "其他地址",
  "tenants.integrations.webhooks.empty": "没有订阅。",
  "tenants.integrations.webhooks.missing": "本站尚未订阅",
  "tenants.integrations.webhooks.loading": "正在加载订阅…",
  "tenants.integrations.webhooks.loadFailed": "无法列出订阅：{{message}}",
  "tenants.integrations.webhooks.shopifyAdminNote": "在 Shopify 后台手工创建的订阅不会显示在这里。",
  "tenants.settings.loadError": "租户设置加载失败。",
  "tenants.settings.packagingCutoffTime": "打包切单时间",
  "tenants.settings.epochDate": "回填起始日",
  "tenants.settings.source.tenant": "来自租户设置",
  "tenants.settings.source.legacy": "未设置",
  "tenants.settings.save": "保存",
  "tenants.settings.saving": "保存中…",
  "tenants.settings.saved": "设置已保存。",
  "tenants.settings.saveFailed": "设置保存失败：{{message}}",
  "tenants.branding.loadError": "品牌信息加载失败。",
  "tenants.branding.name": "组织名称",
  "tenants.branding.save": "保存名称",
  "tenants.branding.saving": "保存中…",
  "tenants.branding.saved": "名称已保存。",
  "tenants.branding.saveFailed": "名称保存失败：{{message}}",
  "tenants.branding.logo": "图标",
  "tenants.branding.logoPreview": "图标预览",
  "tenants.branding.noLogo": "未设置图标，显示 Fastcade 默认图标。",
  "tenants.branding.logoHint": "PNG、JPEG 或 WebP，不超过 256 KB。显示在侧边栏左上角。",
  "tenants.branding.logoTypeInvalid": "请选择 PNG、JPEG 或 WebP 图片。",
  "tenants.branding.logoTooLarge": "图片超过 256 KB。",
  "tenants.branding.uploading": "上传中…",
  "tenants.branding.uploadFailed": "图标上传失败：{{message}}",
  "tenants.branding.removeLogo": "移除图标",
  "tenants.branding.removeFailed": "图标移除失败：{{message}}",
  "tenants.sections.nav": "设置分区",
  "tenants.sections.branding.title": "品牌",
  "tenants.sections.branding.description": "侧边栏左上角显示的组织名称与图标。",
  "tenants.sections.integrations.title": "集成",
  "tenants.sections.integrations.description": "生产环境实时流量使用的 Shopify 与 Onfleet 凭据。",
  "tenants.sections.operations.title": "运营参数",
  "tenants.sections.operations.description": "打包与回填使用的参数。留空则回退到旧配置。",
  "tenants.integrations.webhooks.summary_one": "{{count}} 个订阅 · {{missing}} 个本站尚未订阅",
  "tenants.integrations.webhooks.summary_other": "{{count}} 个订阅 · {{missing}} 个本站尚未订阅",
  "tenants.integrations.webhooks.summaryFailed": "列表加载失败",
  "tenants.settings.edit": "编辑{{label}}",
  "tenants.settings.cancel": "取消",
  "tenants.settings.resetToDefault": "恢复默认",
  "deliveryFlow.page.title": "配送流程",
  "deliveryFlow.page.headline": "配送流程决定物流配送看板的行、列和截止时间",
  "deliveryFlow.page.subtitle": "行 = 批次，列 = 步骤（配送单走到哪一步），步骤之间的箭头 = 谁来推进、什么时候。每个租户一份。",
  "deliveryFlow.loadError": "配送流程加载失败。",
  "deliveryFlow.sections.template.title": "模板",
  "deliveryFlow.sections.template.description": "模板决定批次、步骤和动作。",
  "deliveryFlow.sections.batch.title": "批次",
  "deliveryFlow.sections.batch.description": "物流配送看板的一行是一个批次：一组一起走流程的配送单。",
  "deliveryFlow.sections.columns.title": "步骤",
  "deliveryFlow.sections.columns.description": "配送单走到哪一步。每一步是看板的一列，都从配送单状态和司机数据推出来，不新增状态。",
  "deliveryFlow.sections.actions.title": "动作",
  "deliveryFlow.sections.actions.description": "步骤之间的箭头：谁来推进，看板从哪里知道它发生了。",
  "deliveryFlow.sections.gates.title": "截止时间",
  "deliveryFlow.sections.gates.description": "时间规则。提醒：系统不拦，只提醒；承诺：对顾客的承诺，不是系统规则。",
  "deliveryFlow.sections.integrations.title": "集成",
  "deliveryFlow.sections.integrations.description": "谁在系统外推进",
  "deliveryFlow.integration.orders": "订单来源",
  "deliveryFlow.integration.ordersValue": "Shopify 订单 webhook（orders/create、paid、updated、cancelled）",
  "deliveryFlow.integration.delivery": "配送执行",
  "deliveryFlow.integration.deliveryValue": "Onfleet（创建司机任务 + 状态 webhook）",
  "deliveryFlow.integration.writeback": "回写",
  "deliveryFlow.integration.writebackValue": "送达时回写 Shopify 配送记录",
  "deliveryFlow.preview.label": "预览 · 物流配送看板会长这样",
  "deliveryFlow.preview.batchColumn": "批次",
  "deliveryFlow.preview.note": "行数 = 看板范围；休息日画成空档行。列和箭头来自「步骤」「动作」两节。",
  "deliveryFlow.row.template": "模板",
  "deliveryFlow.template.hgs_same_day": "当日配送",
  "deliveryFlow.templateDescription.hgs_same_day": "按配送日 · 自有司机 · Onfleet",
  "deliveryFlow.templateInUse": "正在使用",
  "deliveryFlow.row.batch": "批次粒度",
  "deliveryFlow.batch.shipping_date": "按配送日：每张配送单都有配送日",
  "deliveryFlow.row.boardRange": "看板范围",
  "deliveryFlow.range.days_one": "{{count}} 天",
  "deliveryFlow.range.days_other": "{{count}} 天",
  "deliveryFlow.row.calendar": "配送日历",
  "deliveryFlow.calendar.invalid": "至少要留一天配送，不能把七天都设为休息日。",
  "deliveryFlow.calendar.note": "休息日在物流配送看板上画成「不配送」空档行；休息日如果有配送单，那一行会标出「休息日」。不拦收单。",
  "deliveryFlow.weekday.1": "一",
  "deliveryFlow.weekday.2": "二",
  "deliveryFlow.weekday.3": "三",
  "deliveryFlow.weekday.4": "四",
  "deliveryFlow.weekday.5": "五",
  "deliveryFlow.weekday.6": "六",
  "deliveryFlow.weekday.7": "日",
  "deliveryFlow.columnRule.awaiting_dispatch": "状态为「已计划」。",
  "deliveryFlow.columnRule.awaiting_assignment": "「已派单」，还没有司机。",
  "deliveryFlow.columnRule.awaiting_departure": "「已派单」且有司机，这位司机当天还没开始第一站。",
  "deliveryFlow.columnRule.en_route": "「配送中」；或「已派单」且有司机，这位司机当天已开始第一站（Onfleet 一次只开始一站）。",
  "deliveryFlow.columnRule.delivered": "「已完成」。",
  "deliveryFlow.columnRule.exception_or_cancelled": "「异常」或「已取消」。",
  "deliveryFlow.action.dispatch": "派单",
  "deliveryFlow.action.assign_driver": "分派司机",
  "deliveryFlow.action.depart": "出发",
  "deliveryFlow.action.deliver": "送达",
  "deliveryFlow.executor.operator": "我们",
  "deliveryFlow.executor.onfleet": "Onfleet",
  "deliveryFlow.executor.driver": "司机",
  "deliveryFlow.actionSignal.dispatch": "派单（POST /api/dispatch/run）",
  "deliveryFlow.actionSignal.assign_driver": "Onfleet taskAssigned 回调",
  "deliveryFlow.actionSignal.depart": "司机开始第一站（taskStarted）",
  "deliveryFlow.actionSignal.deliver": "taskCompleted，回写 Shopify 配送记录",
  "deliveryFlow.row.timezone": "时区",
  "deliveryFlow.gate.packaging_cutoff": "配送单打印截止",
  "deliveryFlow.gate.dispatch_cutoff": "派单截止",
  "deliveryFlow.gate.delivery_window": "送达时段",
  "deliveryFlow.window.start": "司机任务最早送达",
  "deliveryFlow.window.end": "送达承诺窗结束",
  "deliveryFlow.window.invalid": "两项都要填，且司机任务最早送达要早于送达承诺窗结束。",
  "deliveryFlow.gateClass.hint": "提醒",
  "deliveryFlow.gateClass.mandatory": "强制",
  "deliveryFlow.gateClass.dispatch": "{{category}} + 收单规则",
  "deliveryFlow.gate.dispatch_cutoff.note": "派单本身不拦，派单预览只提示「已过截止」；收单时，配送日为今天、且已过此时间的品项不生成配送单。",
  "deliveryFlow.gateClass.promise": "承诺",
  "deliveryFlow.source.default": "默认",
  "tenants.branding.editName": "编辑名称",
  "tenants.branding.cancel": "取消",
  "tenants.branding.changeLogo": "更换",
  "tenants.integrations.editNote": "保存前会先验证新凭据，并整组替换。已保存的密钥不会再次显示。",
  "tenants.integrations.shopify.secretHint": "API secret 与 Webhook secret 至少填写一项。",
  "overview.headline": "今天已送达 {{delivered}} / {{total}}；明天 {{tomorrow}} 待派单 {{pending}} 张",
  "overview.headlineNoDispatch": "全站状态",
  "overview.subtitle": "这一页回答「全站现在怎么样」。要动手的事，每张卡片都直接链到对应页面。",
  "overview.loading": "加载中…",
  "overview.loadError": "加载失败",
  "overview.days.title": "配送日",
  "overview.days.open": "去物流配送",
  "overview.days.empty": "没有配送单",
  "overview.days.delivered": "{{delivered}} / {{total}} 已送达",
  "overview.days.total_one": "{{count}} 张",
  "overview.days.total_other": "{{count}} 张",
  "overview.inbox.open": "打开",
  "overview.outcomes.title": "最近 3 个配送日",
  "overview.outcomes.subtitle": "送达 · 晚于 {{at}}",
  "overview.outcomes.inProgress": "进行中 · {{delivered}} / {{total}}",
  "overview.outcomes.done": "{{delivered}} · 晚 {{late}}",
  "overview.outcomes.empty": "还没有配送日",
  "overview.integrations.title": "集成",
  "overview.integrations.open": "集成与设置",
  "overview.integrations.lastWebhook": "最近 webhook {{ago}}",
  "overview.integrations.noWebhook": "24 小时内没有 webhook",
  "overview.integrations.verified": "凭据 {{date}} 校验通过",
  "overview.integrations.unverified": "凭据未校验",
  "overview.demand.title": "明天 {{date}} 需求",
  "overview.demand.empty": "明天还没有需求",
  "overview.days.tomorrow": "明天",
  "overview.inbox.sub.post_cutoff_order_change": "配送单打印截止后，订单又有改动",
  "overview.inbox.sub.post_dispatch_cancellation": "派单后订单被取消、退款，或改了数量 / 地址",
  "overview.inbox.sub.dispatch_failed": "Onfleet 创建 / 取消司机任务失败，或司机任务送达失败",
  "overview.demand.subtitle": "件 · 来自今日需求",
  "overview.demand.shopify.consistent": "Shopify 侧一致",
  "overview.demand.shopify.mismatch_one": "Shopify 侧 {{count}} 项不一致",
  "overview.demand.shopify.mismatch_other": "Shopify 侧 {{count}} 项不一致",
  "overview.demand.shopify.unavailable": "Shopify 侧暂无法核对",
  "search.placeholder": "订单号、配送单、司机任务短号",
  "search.ariaLabel": "搜索订单号、配送单、司机任务短号",
  "search.group.orders": "订单",
  "search.group.jobs": "配送单",
  "search.group.tasks": "司机任务",
  "search.taskJobs_one": "{{count}} 张配送单",
  "search.taskJobs_other": "{{count}} 张配送单",
  "search.minChars": "至少输入 2 个字符",
  "search.loading": "搜索中…",
  "search.empty": "没有匹配的单号",
  "search.groupError": "这一类搜索失败",
  "search.footer": "↑↓ 选择 · ↵ 打开 · Esc 关闭"
}
